import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        /* login*/
        t1: "Bridging Divides",
        t2: "Login as a",
        t2_2: "Select a role to log in to your already created account",
        t3: "Teacher",
        t4: "Student",
        t5: "Translator",
        t6: "Researcher",
        t7: "Continue",
        t8: "Don't have an account?",
        t8_2: "Already have an account?",
        t9: "Create new account",
        t9_2: "Don't have an account yet? Select your role below to create a new account.",
        t10: "Please select a category to continue",
        t11: "Ok",
        t12: "Deny",
        t13: "Close",
        /* loginpage 2 */
        t14: "Email",
        t14_1: "Emails",
        t15: "Email is required",
        t16: "Enter a valid email",
        t17: "Password",
        t18: "Password is required",
        t19: "Password must consist of at least 8 letters",
        t20: "Forgot password?",
        t20_1: "Did you forget your password? ",
        t20_2: "Reset it",
        t21: "Sign In",
        t22: "Remember my details next time I log in.",
        /* createnewaccountcommon */
        t23: "You are a",
        t24: "Already have an account?",
        t25: "Login",
        /* StudentSignUp1*/
        t26: "Password do not match",
        t27: "Full Name",
        t28: "Enter a valid name",
        t29: "Full name is required",
        t30: "Confirm Password",
        /* StudentSignUp2*/
        t31: 'Preferred Language',
        t32: 'Select a language',
        t33: 'School',
        t33_1: "Schools",
        t34: 'Select a school',
        t35: 'Grade',
        t36: 'Select a grade',
        t37: 'Class',
        t38: 'Select a class',
        t39: 'Select a teacher',
        /* StudentSignUp3*/
        t40_1: 'Tell us about yourself',
        t40_2: 'Please enter atleast 1 hobby',
        t40_3: 'Please enter atleast 1 sport',
        t40_4: 'Please enter atleast 1 movie',
        t40_5: 'Please enter atleast 1 actor',
        t40_6: 'Please tell about you',
        t40_7: 'Hobbies',
        t40_8: 'Movies',
        t40_9: 'Actors',
        t40_10: 'Sports',
        t40_11: 'Press enter after typing - max 2',
        t40: 'Select a gender',
        t41: 'Date of birth',
        t42: 'Select your date of birth',
        t43: 'Gender',
        t44: 'Personal interests',
        t45: 'Describe about your personal interests',
        t46: 'I have read and accepted the terms & conditions',
        t47: 'Please agree the terms',
        t48: 'Attention',
        t49: 'Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains.',
        t50: 'Agree',
        t51: 'Decline',
        t52: 'Submit',
        t53: 'Terms and Conditions',
        t54: 'Your account has been successfully created. Please check your email for verification.',
        t54_1: 'Your account has been successfully created. Please login to continue.',
        t54_2: 'Your account has been successfully created. Please wait until you are approved by the teacher.',
        /* teacherSignUp2*/
        t55: 'District',
        t56: 'Select a district',
        t57: 'Mobile Number (07xxxxxxxx)',
        t58: 'Mobile number is required',
        t59: 'Enter a valid mobile number',
        /*password check */
        t60: 'Password must contain at least 1 uppercase letter',
        t61: 'Password must contain at least 1 lowercase letter',
        t62: 'Password must contain at least 1 numeric digit',
        t63: 'Password must contain at least 1 special character(@,#..)',
        t64: 'Password length must be greater than 8 characters',
        t65: 'Password strength : ',
        t66: 'Weak',
        t67: 'Medium',
        t68: 'Strong',
        /* forgot password page 1 */
        t69: 'Forgot your password?',
        t70: 'Send Link',
        t71: 'Enter OTP',
        t72: 'Enter the OTP sent to the your email account',
        t73: 'Resend in ',
        t74: 'Enter the email of your account',
        t74_1: "Enter your email address. We will send you a link to reset your password.",
        t75: 'Verify',
        t76: 'Create Your New Password',
        t78: 'Your account password has been changed successfully',
        t78_1: 'Account password has been changed successfully',
        /*student dashboard */
        t79: 'Welcome, ',
        t80: 'Connect. Share. Inspire.',
        t81: 'Ready to explore new connections and share your stories? Dive into your dashboard to connect with your pen pal, discover new perspectives, and make a difference today.',
        t82: "Let's build bridges and create harmony, one letter at a time.",
        /* student signup 3 remaining */
        t83: 'Favourite actor',
        t84: 'Favourite quote',
        t85: 'Favourite subject',
        t86: 'Enter favourite subject',
        t87: 'Enter favourite actor',
        t88: 'Enter favourite quote',
        t89: 'Invalid actor',
        t90: 'Invalid subject',
        t91: 'Invalid quote',
        /* error alert*/
        t92: 'This email/username is already registered. Please use a different one or log in.',
        t93: 'No internet connection. Please check your network and try again.',
        t94: 'An error occurred. Please try again.',
        t95: 'Error',
        t96: 'Close',
        /* student signup error alert*/
        t97: 'Please ask your teacher to sign up first.',
        /* Empty array dialog */
        t98: 'There is no registered schools is your district. Please ask your teacher to register first.',
        /* user login error alert */
        t99: 'Please register first.',
        t100: 'Invalid credientials. Please try again',
        t101: 'Account is not active. Please ask the teacher to activate',
        t102: 'Account is not active or invalid credientials',
        /* teacher dashboard */
        t103: 'Empower your students and connect with other educators in shaping the next generation of leaders. We’re here to support you every step of the way.',
        t104: 'Overview',
        t105: 'Registered students',
        t106: 'Pending invitations',
        t107: 'Manage students',
        t108: 'Student Activity',
        t109: 'Inbox',
        /* teacher - manage students page */
        t110: 'Manage students',
        t111: 'Invite students',
        t112: 'Approve requests',
        t113: 'Reset passwords',
        t113_1: 'Reset passwords requests',
        t113_2: "Reset student passwords",
        t114: 'Send reminder',
        /* teacher- invite students page */
        t115: 'Email of student',
        t116: 'Send',
        t117: 'Invitation sent succesfully',
        t118: 'Email of student',
        /* error alert invitation send*/
        t119: 'The student is already registered',
        t120: 'An invitation has already been sent to this student',
        /* teacher request select page */
        t121: 'Account delete requests',
        t122: 'Registration requests',
        /* delete request page */
        t123: 'Accept',
        t124: 'Decline',
        t125: 'No account delete request found',
        /* teacher approve registration request page */
        t126: 'No requests found',
        /*teacher send reset password link page */
        t127: 'Reset password link sent succesfully',
        t127_2: 'Invitation sent succesfully',
        t127_3: 'You are not allowed to sign up.',
        t128: 'Student is not registered.',
        /* class details page teacher */
        t129: 'Download Successfull',
        t130: 'All',
        t131: 'Active',
        t132: 'Inactive',
        t131_1: 'Active',
        t132_1: 'Inactive',
        t133: 'Download',
        t134: 'No data found to download',
        t135: 'No students found',
        t136: 'Student name',
        t137: "Last week's activity",
        t138: 'Status',
        /* teacherview student detail */
        t139: 'Student details',
        t140: 'Set status',
        t141: 'Delete',
        t142: 'Updated successfully',
        t143: 'This action will delete the student account permanantly. Please confirm',
        t143_2: 'This action will delete this teacher account permanantly. Please confirm',
        t144: 'Confirm',
        t145: 'Cancel',
        t146: 'Update',
        /* teacher profile page */
        t147: 'Your profile',
        t147_2: 'Details',
        t148: 'Email',
        t149: 'District',
        t150: 'School',
        t151: 'Grade',
        t152: 'Class',
        t152_2: 'Personal interests',
        t152_3: 'Bank account name',
        t152_4: 'Contact details',
        t152_5: 'Bank account number',
        t152_6: 'Bank name',
        t152_7: 'Bank branch name',
        /* teacher setting page */
        t153: 'Settings',
        t154: 'Edit profile',
        t155: 'Change password',
        t156: 'Help and support',
        t157: 'Privacy policy',
        t158: 'Delete account',
        t159: 'Logout',
        t160: 'This action will delete your account permanantly. Please confirm',
        t160_1: "The delete request will be send to the teacher. The account will be deleted as soon as the teachers accepts the request.",
        t161: 'This action will log out you from your account. Please confirm',
        /* teacher change password page */
        t162: 'Change password',
        t163: 'This will change your password. Please confirm',
        t164: 'Password changed successfully.',
        /* teacher update details page */
        t165: 'Details updated successfully.',
        t166: 'This will update your details. Please confirm',
        /* student profile */
        t167: 'Hobbies:',
        t168: 'Sports:',
        t169: 'Actors:',
        t170: 'Movies:',
        /* penpal profile */
        t171: "Penpal's profile",
        t172: 'Message',
        t172_2: 'Send message',
        /*student edit profile */
        t173: "Ensure the file size is less than 1MB.",
        t174: "Image size is greater than the expected size. Image size should be less than 1 MB",
        t174_2: "Image should be a square (width must be equal to height).",
        /*translator greeting */
        t175: "Your role is vital in bridging communication and fostering understanding between students. Thank you for helping create meaningful connections.",
        /* translator dashboard */
        t176: 'Pending',
        t177: 'Translated',
        t178: 'Translate & Moderate mails',
        t179: 'Report history',
        t180: 'Notifications',
        /* researcher dashboard */
        t181: 'Translations',
        t182: 'Treatment',
        t183: 'Control',
        t184: 'Teachers',
        t185: 'Translators',
        t186: 'Students',
        t187: 'Chats today',
        t188: 'Translated',
        t189: 'Rejected',
        t190: 'Pending',
        t191: 'Manage data',
        t192: 'Manage invitations',
        t193: 'Penpal matching',
        t194: 'Reset Passwords',
        t195: 'Student participation',
        t195_2: 'Download data',
        t196: 'Empowering knowledge and fostering connections, your insights help shape meaningful learning experiences. We’re here to support your research every step of the way.',
        /* reacher view teacher profile */
        t197: 'Teacher details',
        /*Researcher manage data */
        t198: 'Select district',
        t199: 'Select school',
        t200: 'Select teacher',
        t201: 'Please select a district first',
        t202: 'Please select a school first',
        t203: 'Please fill atleast one option',
        t204: 'Search',
        t205: 'No students found',
        t206: 'No teachers found',
        t207: 'View',
        t208: 'View messages',
        t209: 'An error occured. Refresh page',
        t210: 'Please select a role',
        t211: 'Role',
        t212: 'Control',
        t213: 'Treatment',
        /* researcher compose mail */
        t214: 'Receiver does not have account.',
        t215: 'Do you want to save this as draft ?',
        t216: 'Yes',
        t217: 'No',
        t218: 'Confirmation required',
        t219: 'Receiver address and body cannot be empty for drafts',
        t220: 'To',
        t221: 'Select the receiver type',
        t222: "Enter receiver's email",
        t223: "Email of the receiver is required",
        t224: "Optional",
        t225: "Message",
        t226: "Body is required",
        t227: "Inbox",
        t228: "Search by mail",
        t229: "Sort by date",
        t230: "Inbox",
        t231: "Sent",
        t232: "Draft",
        t233: "Compose new",
        t234: "Email",
        t235: "From",
        t236: "Subject",
        /*student penpal error */
        t237: "Penpal is not assigned yet.",
        t238: "Type in english",
        t239: "Type in sinhala",
        t240: "Type in tamil",
        t241: "This student is not your class",
        t242: "Rejected",
        /* translator edit profile */
        t243: "Bank account name",
        t244: "Bank name",
        t245: "Bank account number",
        t246: "Bank branch",
        t247: "Bank account name is required",
        t248: "Bank name is required",
        t249: "Bank account number is required",
        t250: "Bank branch name is required",
        t251: "Enter a valid bank account name",
        t252: "Enter a valid bank name",
        t253: "Enter a valid bank account number",
        t254: "Enter a valid bank branch name",
        t255: 'One or both students not found',

        t256: 'Search by mail or name',
        t257: "Provided email is not registered",
        /*researcher invitation */
        t258: "User already registered",
        t259: "User already invited",
        t260: 'Reply',
        t261: 'Sent requests',
        t262: 'Resend',
        t263: 'Invitation sent successfully',

        t267: 'Send invitations',
        t268: 'Role:',
        t269: 'Select a role',
        t270: 'Sent invitations',
        t271: 'Please select a role',
        /*forgot password */
        t272: 'User is not registered.',

        t273: 'Please go to your email and click the link to continue.',
        t274: 'You have not requested a password change',


        t275: 'Message sent successfully.',
        t276: 'Message saved successfully.',
        t277: 'Message translated successfully.',
        t278: 'Message rejected successfully.',
        t279: 'Message forwarded successfully.',
        t280: 'Select district',
        t281: 'Search by student name',
        t282: 'Upload',
        t283: 'Match',
        t284: 'Need to select 2 students.',
        t285: 'Every student is occupied.',

        t286: 'Download data',
        t287: 'Student randomization',
        t288: 'Translator Payment Details',
        t289: 'Teacher Contact List',
        t290: 'Letter Exchange Data',
        t291: 'Format: ',
        t292: 'Select format',

        t293: 'Select a recipient',
        // t294:'Select format',

        //homepage
        t294: 'Connecting Students. Building Harmony.',
        t295: 'A digital penpal platform',
        t296: 'fostering unity and understanding.',
        t297: 'What is Bridging Divides?',
        t298: "Bridging Divides is a digital penpal platform designed to connect Sri Lankan students across language barriers and encourage harmony. Students can find penpals, exchange emails, and build friendships while teachers monitor their interactions for safety. The platform also includes translators who help students communicate seamlessly in Sinhala and Tamil, ensuring meaningful and inclusive conversations that promote unity and understanding.",
        t299: 'Already a Participant?',
        t300: 'Dashboard Highlights',
        t301: 'School Partners',
        t302: 'Total Schools Participating:',
        t303: 'Total Students:',
        t304: 'Total Teachers:',
        t305: 'Meet the Experts Behind the Project',
        t306: 'Our Supporters & Collaborators',
        t307: 'See the Journey',
        t308: 'School Participating',
        t309: 'Western province:',
        t310: 'Eastern province:',
        t311: 'Northern province:',
        t312: 'Southern province:',
        t313: 'Central province:',
        t314: 'North Central province:',
        t315: 'North Western province:',
        t316: 'Uva province:',
        t317: 'Sabaragamuwa province: ',
        t318: 'students',
        t319: 'Letters Exchanged',
        t320: 'Total Letters Sent this week:',
        t321: 'Average Word Count per Letter:',
        t322: 'Total Words translated:',
        t323: 'words',
        t324: 'Sentiment Scores',
        t325: 'Positive',
        t326: 'Negative',
        t327: 'Neutral',
        t328: 'Contact us',
        t329: 'Privacy Policy',
        t330: 'Terms of Service',
        t331: 'Uniting Students,',
        t332: 'One Letter at a Time',
        t333: 'A digital pen pal platform fostering friendships,',
        t334: 'understanding, and harmony among students in Sri Lanka.',
        t335: 'About Bridging Divides',
        t336: "At Bridging Divides, we believe that meaningful connections can break barriers and build a more united future. Our platform is a digital pen pal initiative designed to foster friendship, understanding, and collaboration between Tamil and Sinhalese students across Sri Lanka. Through the power of letter exchanges, we encourage students to share their thoughts, experiences, and cultures in a safe and structured environment. By engaging in open conversations, students develop empathy, reduce prejudices, and build lasting bonds that transcend geographical and ethnic differences.",
        t337: "Our platform integrates language translation, sentiment analysis, and researcher insights to enhance cross-cultural communication and track positive social impact. Supported by educators, researchers, and partner organizations, we strive to create a generation that values unity and mutual respect.",
        t338: "Join us in shaping a more harmonious and connected Sri Lanka, one letter at a time.",
        t339: "Support",
        t340: "Subscribe to our newsletter",
        t341: "Want to stay up to date with news and updates",
        t342: "about our product? Subscribe.",
        t343: "Enter your email",
        t344: "By subscribing to our newsletter you agree to our",
        t345: "privacy policy and will get commercial communication.",
        t346: "Bridging Divides.",

        t347: "Account is not verified. Please verify it first by clicking the link sent to your email.",
        t348: "A teacher has already been identified with this class. Registration failed.",
        t349: "User not registered",

        t350: "Reject",
        t351: "Forward",
        t352: "Unmatched students",
        t353: "Login as Teacher",
        t354: "Login as Student",
        t355: "Login as Researcher",
        t356: "Login as Translator",
        t357: "Register as Teacher",
        t358: "Register as Student",
        t359: "Register as Researcher",
        t360: "Register as Translator",
        t361: "Ethnicity",
        t362: 'Select a Ethnicity',

        t363: "Your Privacy, Our Priority",
        t364: "At Bridging Divides, we take privacy seriously and are committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data.",
        t365: "Information We Collect",
        t366: "To provide a safe and effective experience, we collect:",
        t367: "Your name, age, and school details (for verification purposes).",
        t368: "Your preferred language (to facilitate penpal matching).",
        t369: "The emails exchanged through the platform (monitored by assigned teachers and translators for safety).",
        t370: "How We Use Your Information",
        t371: "Match you with a suitable penpal for meaningful conversations.",
        t372: "Enable translations so you can communicate across language barriers.",
        t373: "Allow teachers to monitor conversations and maintain a safe environment.",
        t374: "Data Security",
        t375: "We do not share your personal information with third parties.",
        t376: "Your messages are only visible to your penpal, assigned teachers, and translators.",
        t377: "All data is stored securely, and access is strictly limited to authorized personnel.",
        t378: "Your Rights",
        t379: "You can request to delete your account at any time.",
        t380: "If you have privacy concerns, you can contact us at bddivides@gmail.com",

        t381: "Need Assistance? We’re Here to Help!",
        t382: "At Bridging Divides, we want to ensure that your experience is smooth, secure, and enjoyable. If you need any help, feel free to reach out to us.",
        t383: "How to Get Support",
        t384: "Email Support:",
        t385: "bddivides@gmail.com – Contact us for any issues, questions, or feedback.",
        t386: "Phone Support:",
        t387: "0771482755 – Reach out for urgent concerns.",
        t388: "Common Issues We Can Help With",
        t389: "Account registration and login issues",
        t390: "Finding a penpal or connecting with a teacher",
        t391: "Reporting inappropriate behavior or technical issues",
        t392: "Understanding how translations work",
        t393: "We’re committed to providing timely support and fostering a positive learning environment for all participants.",

        t394: "By signing up for Bridging Divides, you acknowledge and agree to the following terms:",
        t395: "1. Eligibility",
        t396: "Registration is exclusively available to participants enrolled in the program. Unauthorized access is not permitted. Users must provide accurate details during registration to ensure a safe and structured experience.",
        t397: "2. User Responsibilities",
        t398: "You agree to communicate respectfully with your penpals and follow ethical online behavior. Messages should be appropriate and align with the goal of fostering unity and friendship. Users must not share personal contact details outside the platform for safety reasons.",
        t399: "3. Monitoring and Moderation",
        t400: "Any inappropriate, offensive, or harmful communication will lead to immediate review and potential removal from the program.",
        t401: "4. Privacy and Data Protection",
        t402: "User information is kept secure and is not shared with third parties.",
        t403: "For more details, please review our Privacy Policy. By proceeding with registration, you agree to abide by these terms and understand that failure to comply may result in account suspension or termination.",

        t404: "Matched students",
        t405: "You do not have a penpal yet",
        t406: "Email: ",
        t407: "Phone: ",
        t408: "Draft deleted successfully",
        t409: "Currently a translator is moderating this.",

        t410: "Dashboard",
        t411: "Your mails",
        t412: "Click to view",
        t413: "(Click the student to view his/her details)",
        t414: "A user already found with same mail",
        t415: "Active students",
        t416: "Language needed",
        t417: "None",
        t418: "Group",
        t419: "Select a group",
        t420: "Pending emails",

        t421: "Translator details",
        t422: "Bank details",
        t423: 'This action will delete this translator account permanantly. Please confirm',

        t424: 'Translator/ researcher details',
        t425: 'Researcher details',

        t426: "Write the reply",
        t427: "Send reply",
        t428: "Mail language",

        t429: "Approve students",
        t430: "Assign schools",
        t431: "No schools found",
        t432: "No researchers found",
        t433: "Others",
        t434: "Sender",
        t435: "Scan",
        t436: "Take photo",
        t437: "Capture",
        t438: "You have already sent 3 mails to penpal within this week. Please wait until next week to send more messages to penpal.",
        t439: "Download translated mails",
        t440: "No mails are translated yet",
        t441: "Email or Username",
        t442: "Email or Username is required",
        t443: "Invalid email or username.",
        t444: "If it's an email, the format should be like test@example.com",
        t445: "Username must be at least 7 characters long and contain only letters and numbers",
        t446: "Get started",
        t447: "Demo",
        t448: "Please select your preferred language to continue. You can always change it later using options in top right corner.",
        t449: "Please select your preferred language to watch the video.",
        t450: "If you are <bold>already registered</bold>, press <bold>'Yes'</bold> to login.",
        t451: "If this is <bold>your first time</bold>, press <bold>'No'</bold> to create a new account.",
        t452: "Personal Details",
        t453: "Password Details",
        t454: "Other Details",
        t455: "Back",
        t456: "No mails found",
        t457: "unread",
        t458: "Step 1",
        t459: "Step 2",
        t460: "Upload students or select from below.",
        t461: "Choose Treat for same-language students, or Control for different-language students.Then click Match to connect them.",
        t462: "Excel sheet format",
        t463: "First column should be student email/username",
        t464: "Second column should be penpal's email/username",
        t465: "Do not put column names.",
        t466: "Third column should be the group(either CONTROL or TREATMENT).",
        t467: "Please enter your email and password to continue.",
        t468: "Please enter your email/username and password to continue.",
        t469: "Words limit is 500 words per mail.",
        t470: "Start Your Message ✉️",
        t471: "Type your new mail in the box on the right.",
        t472: "Say hello, share your story, or ask a question  your pen pal is waiting to hear from you!",
        t473: "Messages",
        t474: "Choose your role (Student, Teacher, Translator, or Researcher) to log in to your account.",
        t475: "Choose your role (Student, Teacher, Translator, or Researcher) to create your account.",
        t476: "Attach",
        t477: "OCR",
      },
    },
    ta: {
      translation: {
        t1: "⁠நல்லிணக்கத்திற்கு உதவும் கரம்",
        t2: "யாராக உள்நுழைகிறீர்கள்",
        t2_2: "ஏற்கனவே உருவாக்கிய கணக்கில் உள்நுழைய உங்கள் பாத்திரத்தைத் தேர்ந்தெடுக்கவும்",
        t3: "ஆசிரியர்",
        t4: "மாணவர்",
        t5: "மொழிபெயர்ப்பாளர்",
        t6: "ஆராய்ச்சியாளர்",
        t7: "தொடரவும்",
        t8: "கணக்கு இல்லையா?",
        t8_2: "ஏற்கனவே கணக்கு உள்ளதா?",
        t9: "கணக்கை உருவாக்கவும்",
        t9_2: "புதிய கணக்கை உருவாக்க உங்கள் பாத்திரத்தைத் தேர்ந்தெடுக்கவும்.",
        t10: "தொடர்வதற்கு ஒன்றை தேர்ந்தெடுக்கவும்",
        t11: "சரி",
        t12: "மறுக்கவும்",
        t13: "மூடுக",
        t14: "மின்னஞ்சல்",
        t14_1: "மின்னஞ்சல்கள்",
        t15: "மின்னஞ்சல் தேவை",
        t16: "சரியான மின்னஞ்சலை உள்ளிடவும்",
        t17: "கடவுச்சொல்",
        t18: "கடவுச்சொல் தேவை",
        t19: "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் கொண்டதாக இருக்க வேண்டும்",
        t20: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
        t20_1: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
        t20_2: "அதை மாற்றவும்",
        t21: "உள்நுழையவும்",
        t22: "என் விவரங்களை நினைவில் வைக்கவும்",
        t23: "நீங்கள் ஒரு",
        t24: "ஏற்கனவே கணக்கு உள்ளதா?",
        t25: "உள்நுழைக",
        t26: "கடவுச்சொற்கள் பொருந்தவில்லை",
        t27: "முழுப்பெயர்",
        t28: "சரியான பெயரை உள்ளிடவும்",
        t29: "முழுப்பெயர் தேவை",
        t30: "கடவுச்சொல்லை உறுதிசெய்யுங்கள்",
        t31: "விருப்பமான மொழி",
        t32: "ஒரு மொழியை தேர்ந்தெடுக்கவும்",
        t33: "பாடசாலை",
        t33_1: "பாடசாலைகள்",
        t34: "ஒரு பாடசாலையைத் தேர்ந்தெடுக்கவும்",
        t35: "தரம்",
        t36: "ஒரு தரத்தை தேர்ந்தெடுக்கவும்",
        t37: "வகுப்பு",
        t38: "ஒரு வகுப்பை தேர்ந்தெடுக்கவும்",
        t39: "ஒரு ஆசிரியரை தேர்ந்தெடுக்கவும்",
        t40_1: "உங்களைப் பற்றி கூறுங்கள்",
        t40_2: "குறைந்தபட்சம் 1 பொழுதுபோக்கு குறிப்பிடவும்",
        t40_3: "குறைந்தபட்சம் 1 விளையாட்டு குறிப்பிடவும்",
        t40_4: "குறைந்தபட்சம் 1 திரைப்படம் குறிப்பிடவும்",
        t40_5: "குறைந்தபட்சம் 1 நடிகரை குறிப்பிடவும்",
        t40_6: "தயவுசெய்து உங்களைப் பற்றி கூறுங்கள்",
        t40_7: "பொழுதுபோக்குகள்",
        t40_8: "திரைப்படங்கள்",
        t40_9: "நடிகர்கள்",
        t40_10: "விளையாட்டுகள்",
        t40_11: "அடித்துவிட்டு Enter ஐ அழுத்தவும் - max 2",
        t40: "ஒரு பாலினத்தை தேர்ந்தெடுக்கவும்",
        t41: "பிறந்த தேதி",
        t42: "பிறந்த திகதியை தேர்ந்தெடுக்கவும்",
        t43: "பாலினம்",
        t44: "தனிப்பட்ட விருப்பங்கள்",
        t45: "உங்கள் தனிப்பட்ட விருப்பங்களை விவரிக்கவும்",
        t46: "நான் விதிமுறைகள் & நிபந்தனைகளை ஏற்றுக்கொண்டேன்",
        t47: "தயவுசெய்து விதிமுறைகளை ஏற்கவும்",
        t48: "கவனம்",
        t49: 'Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains. Terms and Conditions set out the terms that apply to the relationship, and the conditions that must be met by both parties, such as what the user must not do when using the site or service, and what rights the business maintains.',
        t50: "ஏற்கவும்",
        t51: "நிராகரிக்கவும்",
        t52: "சமர்ப்பிக்கவும்",
        t53: "விதிமுறைகள் & நிபந்தனைகள்",
        t54: "உங்கள் கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது. உறுதிப்படுத்த உங்கள் மின்னஞ்சலைப் பார்க்கவும்.",
        t54_1: 'உங்கள் கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது. தொடர உள்நுழையவும்.',
        t54_2: 'உங்கள் கணக்கு வெற்றிகரமாக உருவாக்கப்பட்டது. தயவுசெய்து ஆசிரியரின் ஒப்புதலுக்காக காத்திருக்கவும்.',
        t55: "மாவட்டம்",
        t56: "ஒரு மாவட்டத்தை தேர்ந்தெடுக்கவும்",
        t57: "கைபேசி எண் (07xxxxxxxx)",
        t58: "கைபேசி எண் தேவை",
        t59: "சரியான கைபேசி எண்ணை உள்ளிடவும்",
        t60: "கடவுச்சொல்லில் குறைந்தது 1 பெரிய ஆங்கில எழுத்து இருக்க வேண்டும்",
        t61: "கடவுச்சொல்லில் குறைந்தது 1 சிறிய ஆங்கில எழுத்து இருக்க வேண்டும்",
        t62: "கடவுச்சொல்லில் குறைந்தது 1 எண் இருக்க வேண்டும்",
        t63: "கடவுச்சொல்லில் குறைந்தது 1 சிறப்பு எழுத்து(@,#..) இருக்க வேண்டும்",
        t64: "கடவுச்சொல்லின் நீளம் 8 எழுத்துகளுக்கு அதிகமாக இருக்க வேண்டும்",
        t65: "கடவுச்சொல் வலிமை:",
        t66: "வலிமையற்றது",
        t67: "நடுத்தர வலிமை",
        t68: "வலிமையானது",
        t69: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
        t70: "Link அனுப்புக",
        t71: "OTP உள்ளிடவும்",
        t72: "உங்கள் மின்னஞ்சலுக்கு அனுப்பிய OTP-ஐ உள்ளிடவும்",
        t73: "மறுபடியும் அனுப்ப ",
        t74: "உங்கள் கணக்கின் மின்னஞ்சலை உள்ளிடவும்",
        t74_1: "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள். உங்கள் கடவுச்சொல்லை மீட்டமைக்க நாங்கள் உங்களுக்கு ஒரு இணைப்பை அனுப்புவோம்.",
        t75: "சரிபார்க்கவும்",
        t76: "புதிய கடவுச்சொல்லை உருவாக்கவும்",
        t78: "உங்கள் கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
        t78_1: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
        t79: "வரவேற்கிறோம், ",
        t80: "இணை. பகிர். ஊக்கமளி.",
        t81: "புதிய இணைப்புகளை ஆராய்ந்து உங்கள் கதைகளைப் பகிரத் தயாரா? உங்கள் பேனா நண்பருடன் இணைவதற்கும், புதிய கண்ணோட்டங்களைக் கண்டறியவும், இன்றே மாற்றத்தை ஏற்படுத்தவும் உங்கள் டாஷ்போர்டிற்கு செல்லுங்கள்.",
        t82: "பாலங்கள் கட்டி நல்லிணக்கத்தை உருவாக்குவோம், ஒரு நேரத்தில் ஒரு எழுத்து.",
        /* மாணவர் பதிவு 3 மீதமுள்ளவை */
        t83: "விருப்பமான நடிகர்",
        t84: "விருப்பமான மேற்கோள்",
        t85: "விருப்பமான பாடம்",
        t86: "உங்கள் விருப்பமான பாடத்தை உள்ளிடவும்",
        t87: "உங்கள் விருப்பமான நடிகரை உள்ளிடவும்",
        t88: "உங்கள் விருப்பமான மேற்கோளினை உள்ளிடவும்",
        t89: "தவறான நடிகர்",
        t90: "தவறான பாடம்",
        t91: "தவறான மேற்கோள்",
        /* பிழை எச்சரிக்கை */
        t92: "இந்த மின்னஞ்சல்/பயனர் பெயர் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளது. தயவுசெய்து வேறொன்றை பயன்படுத்தவும் அல்லது உள்நுழையவும்.",
        t93: "இன்டர்நெட் இணைப்பு இல்லை. உங்கள் நெட்வொர்க்கை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
        t94: "ஒரு பிழை ஏற்பட்டுள்ளது. மீண்டும் முயற்சிக்கவும்.",
        t95: "பிழை",
        t96: "மூடுக",
        /* மாணவர் பதிவு பிழை எச்சரிக்கை */
        t97: "முதலில் உங்கள் ஆசிரியரை பதிவு செய்யச் சொல்லவும்.",
        /* காலியான வரிசை உரையாடல் */
        t98: "உங்கள் மாவட்டத்தில் எந்த பாடசாலைகளும் பதிவு செய்யப்படவில்லை. முதலில் உங்கள் ஆசிரியரை பதிவு செய்யச் சொல்லவும்.",
        /* பயனர் உள்நுழைவு பிழை எச்சரிக்கை */
        t99: "முதலில் பதிவு செய்யவும்.",
        t100: "தவறான உள்நுழைவு தகவல்கள். தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
        t101: "கணக்கு செயல்பாட்டில் இல்லை. தயவுசெய்து ஆசிரியரிடம் செயல்படுத்தச் சொல்லவும்.",
        t102: "கணக்கு செயல்பாட்டில் இல்லை அல்லது தவறான உள்நுழைவு தகவல்கள்.",
        /* ஆசிரியர் டாஷ்போர்டு */
        t103: "உங்கள்  மாணவர்களுக்கு அதிகாரம் அளிப்பது மட்டுமின்றி இன்னும் பல ஆசிரியர்களுடன் இணைந்து எதிர்கால தலைவர்களை உருவாக்குங்கள் . உங்கள் பயணத்தின் ஒவ்வொரு படியிலும் உங்களுக்கு உதவ நாங்கள் உள்ளோம்.",
        t104: "மேற்பார்வை",
        t105: "பதிவு செய்யப்பட்ட மாணவர்கள்",
        t106: "நிலுவையில் உள்ள அழைப்புகள்",
        t107: "மாணவர் நிர்வகிப்பு",
        t108: "மாணவர் செயல்பாடு",
        t109: "உள்வருகை",
        /* ஆசிரியர் - மாணவர்களை நிர்வகிக்கும் பக்கம் */
        t110: "மாணவர்களை நிர்வகிக்கவும்",
        t111: "மாணவர்களை அழைக்கவும்",
        t112: "கோரிக்கைகளை அங்கீகரிக்கவும்",
        t113: "கடவுச்சொற்களை மீட்டமைக்கவும்",
        t113_1: "கடவுச்சொல் மீட்டமைக்கும் கோரிக்கைகள்",
        t113_2: "மாணவர்களின் கடவுச்சொற்களை மீட்டமைக்கவும்",
        t114: "நினைவுபடுத்தவும்",
        /* ஆசிரியர் - மாணவர்களை அழைக்கும் பக்கம் */
        t115: "மாணவரின் மின்னஞ்சல்",
        t116: "அனுப்பவும்",
        t117: "அழைப்பு வெற்றிகரமாக அனுப்பப்பட்டது",
        t118: "மாணவரின் மின்னஞ்சல்",
        /* பிழை எச்சரிக்கை - அழைப்பு அனுப்புதல் */
        t119: "மாணவர் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளார்",
        t120: "இந்த மாணவருக்கு ஏற்கனவே அழைப்பு அனுப்பப்பட்டுள்ளது",
        /* ஆசிரியர் கோரிக்கை தேர்வு பக்கம் */
        t121: "கணக்கு நீக்கும் கோரிக்கைகள்",
        t122: "பதிவு கோரிக்கைகள்",
        /* கணக்கு நீக்க கோரிக்கை பக்கம் */
        t123: "ஏற்கவும்",
        t124: "நிராகரிக்கவும்",
        t125: "கணக்கு நீக்கும் கோரிக்கை எதுவும் இல்லை",
        /* ஆசிரியர் பதிவு கோரிக்கையை அங்கீகரிக்கும் பக்கம் */
        t126: "எந்த கோரிக்கைகளும் இல்லை",
        /* ஆசிரியர் கடவுச்சொல் மீட்டமைப்பு இணைப்பு அனுப்பும் பக்கம் */
        t127: "கடவுச்சொல் மீட்டமைப்பு லிங்க் வெற்றிகரமாக அனுப்பப்பட்டது",
        t127_2: "அழைப்பு வெற்றிகரமாக அனுப்பப்பட்டது",
        t127_3: "உங்களுக்கு பதிவு செய்ய அனுமதி இல்லை",
        t128: "மாணவர் பதிவு செய்யப்படவில்லை",
        /* வகுப்பு விவரங்கள் - ஆசிரியர் */
        t129: "பதிவிறக்கம் வெற்றிகரமாக முடிந்தது",
        t130: "அனைத்தும்",
        t131: "செயலில் உள்ளவை",
        t132: "செயல் அற்றவை",
        t131_1: "செயலிலுண்டு",
        t132_1: "செயலில்லை",
        t133: "பதிவிறக்கவும்",
        t134: "பதிவிறக்க எந்த தகவலும் இல்லை",
        t135: "எந்த மாணவரும் இல்லை",
        t136: "மாணவரின் பெயர்",
        t137: "கடந்த வார செயல்பாடு",
        t138: "நிலை",
        /* ஆசிரியர் பார்வை - மாணவர் விவரங்கள் */
        t139: "மாணவர் விவரங்கள்",
        t140: "நிலையை அமைக்கவும்",
        t141: "நீக்கவும்",
        t142: "வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        t143: "இந்த நடவடிக்கை மாணவர் கணக்கை நிரந்தரமாக நீக்கும். தயவுசெய்து உறுதிப்படுத்தவும்.",
        t143_2: "இந்த நடவடிக்கை ஆசிரியர் கணக்கை நிரந்தரமாக நீக்கும். தயவுசெய்து உறுதிப்படுத்தவும்.",
        t144: "உறுதிப்படுத்தவும்",
        t145: "நிராகரி",
        t146: "புதுப்பிக்கவும்",
        /* ஆசிரியர் சுயவிவரப் பக்கம் */
        t147: "உங்கள் சுயவிவரம்",
        t147_2: "விவரங்கள்",
        t148: "மின்னஞ்சல்",
        t149: "மாவட்டம்",
        t150: "பாடசாலை",
        t151: "தரம்",
        t152: "வகுப்பு",
        t152_2: "தனிப்பட்ட விருப்பங்கள்",
        t152_3: "வங்கி கணக்கு பெயர்",
        t152_4: "தொடர்பு விவரங்கள்",
        t152_5: "வங்கி கணக்கு எண்",
        t152_6: "வங்கி பெயர்",
        t152_7: "வங்கி கிளை பெயர்",
        /* ஆசிரியர் அமைப்புகள் பக்கம் */
        t153: "அமைப்புகள்",
        t154: "சுயவிவரத்தை திருத்தவும்",
        t155: "கடவுச்சொல்லை மாற்றவும்",
        t156: "உதவி மற்றும் ஆதரவு",
        t157: "தனியுரிமை கொள்கை",
        t158: "கணக்கை நீக்கவும்",
        t159: "வெளியேறவும்",
        t160: "இந்த நடவடிக்கை உங்கள் கணக்கை நிரந்தரமாக நீக்கும். தயவுசெய்து உறுதிப்படுத்தவும்.",
        t160_1: "கணக்கை நீக்க கோரிக்கை ஆசிரியருக்கு அனுப்பப்படும். ஆசிரியர் கோரிக்கையை ஏற்றவுடன் கணக்கு நீக்கப்படும்.",
        t161: "இந்த நடவடிக்கை உங்களை தளத்தில் இருந்து வெளியேற்றும். தயவுசெய்து உறுதிப்படுத்தவும்.",
        /* ஆசிரியர் கடவுச்சொல் மாற்றம் பக்கம் */
        t162: "கடவுச்சொல்லை மாற்றவும்",
        t163: "இது உங்கள் கடவுச்சொல்லை மாற்றும். தயவுசெய்து உறுதிப்படுத்தவும்",
        t164: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது.",
        /* ஆசிரியர் விவரங்களை புதுப்பிக்கும் பக்கம் */
        t165: "விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன.",
        t166: "இது உங்கள் விவரங்களை புதுப்பிக்கும். தயவுசெய்து உறுதிப்படுத்தவும்",
        /* மாணவர் சுயவிவரம் */
        t167: "பொழுதுபோக்கு:",
        t168: "விளையாட்டு:",
        t169: "நடிகர்கள்:",
        t170: "திரைப்படங்கள்:",
        /* பேன்பால் சுயவிவரம் */
        t171: "பேன்பாலின் சுயவிவரம்",
        t172: "செய்தி",
        t172_2: "செய்தி அனுப்பவும்",
        /* மாணவர் சுயவிவரம் திருத்தம் */
        t173: "கோப்பு அளவு 1MBக்கு குறைவாக இருக்க வேண்டும்.",
        t174: "பட அளவு அதிகமாக உள்ளது. பட அளவு 1MBக்கு குறைவாக இருக்க வேண்டும்.",
        t174_2: "படம் ஒரு சதுரமாக இருக்க வேண்டும் (அகலம் உயரத்திற்குச் சமமாக இருக்க வேண்டும்).",
        /* மொழிபெயர்ப்பாளர் வரவேற்பு */
        t175: "மாணவர்களிடையே தகவல்தொடர்பு மற்றும் புரிதலை வளர்ப்பதில் உங்கள் பங்கு முக்கியமானது. அர்த்தமுள்ள இணைப்புகளை உருவாக்க உதவியதற்கு நன்றி.",
        /* மொழிபெயர்ப்பாளர் டாஷ்போர்டு */
        t176: "நிலுவையில் உள்ளவை",
        t177: "மொழிபெயர்ந்தவை",
        t178: "மின்னஞ்சலை மொழிபெயர்த்து மிதப்படுத்தல்",
        t179: "அறிக்கை வரலாறு",
        t180: "அறிவிப்புகள்",
        t181: "மொழிபெயர்ப்பு",
        t182: "சிகிச்சை",
        t183: "கட்டுப்பாடு",
        t184: "ஆசிரியர்",
        t185: "மொழிபெயர்பாளர்",
        t186: "மாணவர்கள்",
        t187: "செய்திகள்(இன்று)",
        t188: "மொழிபெயர்ப்பு செய்யப்பட்டவை",
        t189: "மறுக்கப்பட்டவை",
        t190: "நிலுவை",
        t191: "தரவுகள்",
        t192: "அழைப்புகள் விபரம்",
        t193: "பென்பால் பொருத்தம்",
        t194: "கடவுச்சொல் மாற்று",
        t195: "மாணவர் பங்கேற்பு",
        t195_2: "பதிவிறக்கவும்",
        t196: "அறிவை மேம்படுத்துதல் மற்றும் இணைப்புகளை வளர்ப்பது மட்டுமில்லாமல், உங்களினுடைய நுண்ணறிவு, அர்த்தமுள்ள கற்றல் அனுபவங்களை வடிவமைப்பதற்கு உதவுகிறது. உங்கள் ஆராய்ச்சியை ஆதரிக்க நாங்கள் இங்கே இருக்கிறோம்.",
        t197: "ஆசிரியர் விவரங்கள்",
        t198: "மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
        t199: "பாடசாலையைத் தேர்ந்தெடுக்கவும்",
        t200: "ஆசிரியரைத் தேர்ந்தெடுக்கவும்",
        t201: "முதலில் மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
        t202: "முதலில் பாடசாலையைத் தேர்ந்தெடுக்கவும்",
        t203: "குறைந்தது ஒரு தேர்வை நிரப்பவும்",
        t204: "தேடுக",
        t205: "மாணவர்கள் யாரும் இல்லை",
        t206: "ஆசிரியர்கள் யாரும் இல்லை",
        t207: "காண்க",
        t208: "செய்திகளை காண்க",
        t209: "பிழை ஒன்று ஏற்பட்டுள்ளது . பக்கத்தைப் புதுப்பிக்கவும்",
        t210: "ஒரு பாத்திரத்தைத் தேர்ந்தெடுக்கவும்",
        t211: "பாத்திரம்",
        t212: "கட்டுப்பாடு",
        t213: "சிகிச்சை",
        t214: "பெறுநருக்கு கணக்கு இல்லை.",
        t215: "இதை சேமிக்க விரும்புகிறீர்களா?",
        t216: "ஆம்",
        t217: "இல்லை",
        t218: "உறுதிப்படுத்தல் தேவை",
        t219: "பெறுநர் முகவரி மற்றும் உட்பொருள் காலியாக இருக்கக்கூடாது",
        t220: "பெறுநர்",
        t221: "பெறுநர் வகையைத் தேர்ந்தெடுக்கவும்",
        t222: "பெறுநரின் மின்னஞ்சல் முகவரி",
        t223: "பெறுநரின் மின்னஞ்சல் தேவை",
        t224: "கட்டாயமில்லை",
        t225: "செய்தி",
        t226: "உட்பொருள் தேவை",
        t227: "உள்வருகை",
        t228: "மின்னஞ்சல் மூலம் தேடுக",
        t229: "தேதியின்படி வரிசைப்படுத்துக",
        t230: "உள்வருகை",
        t231: "அனுப்பியது",
        t232: "வரைவு",
        t233: "புதிய அஞ்சல்",
        t234: "மின்னஞ்சல்",
        t235: "அனுப்புநர்",
        t236: "பொருள்",
        t237: "பேன்பால் இன்னும் நியமிக்கப்படவில்லை.",
        t238: "ஆங்கிலத்தில் தட்டச்சு செய்யவும்",
        t239: "சிங்களத்தில் தட்டச்சு செய்யவும்",
        t240: "தமிழில் தட்டச்சு செய்யவும்",
        t241: "இந்த மாணவர் உங்கள் வகுப்பில் இல்லை",
        t242: "நிராகரிக்கப்பட்டது",
        t243: "வங்கி கணக்கின் பெயர்",
        t244: "வங்கியின் பெயர்",
        t245: "வங்கி கணக்கின் எண்",
        t246: "வங்கியின் கிளை",
        t247: "வங்கி கணக்கின் பெயர் தேவை",
        t248: "வங்கியின் பெயர் தேவை",
        t249: "வங்கி கணக்கு எண் தேவை",
        t250: "வங்கி கிளையின் பெயர் தேவை",
        t251: "சரியான வங்கி கணக்கு பெயரை உள்ளிடவும்",
        t252: "சரியான வங்கி பெயரை உள்ளிடவும்",
        t253: "சரியான வங்கி கணக்கு எண்ணை உள்ளிடவும்",
        t254: "சரியான வங்கி கிளை பெயரை உள்ளிடவும்",
        t255: "ஒரு அல்லது இருவரும் காணப்படவில்லை",
        t256: "மின்னஞ்சல் அல்லது பெயர் மூலம் தேடவும்",
        t257: "கொடுக்கப்பட்ட மின்னஞ்சல் பதிவு செய்யப்படவில்லை",
        t258: "பயனர் ஏற்கனவே பதிவு செய்யப்பட்டுள்ளார்",
        t259: "பயனர் ஏற்கனவே அழைக்கப்பட்டுள்ளார்",
        t260: "பதில்",

        t261: 'அனுப்பிய கோரிக்கைகள்',
        t262: 'மீண்டும் அனுப்பு',
        t263: 'அழைப்பு வெற்றிகரமாக அனுப்பப்பட்டது',

        t267: 'அழைப்புகளை அனுப்பு',
        t268: 'பாத்திரம்:',
        t269: 'ஒரு பாத்திரத்தைத் தேர்ந்தெடுங்கள்',
        t270: 'அனுப்பிய கோரிக்கைகள்',
        t271: 'ஒரு பாத்திரத்தைத் தேர்ந்தெடுக்கவும்',

        t273: "தொடர்வதற்கு, உங்கள் மின்னஞ்சலுக்குச் அனுப்பியுள்ள இணைப்பைக் கிளிக் செய்யவும்.",
        t274: 'நீங்கள் கடவுச்சொல் மாற்றத்தைக் கோரவில்லை.',


        t275: 'செய்தி வெற்றிகரமாக அனுப்பப்பட்டது.',
        t276: 'செய்தி வெற்றிகரமாக சேமிக்கப்பட்டது.',
        t277: 'செய்தி வெற்றிகரமாக மொழிபெயர்க்கப்பட்டது.',
        t278: 'செய்தி நிராகரிக்கப்பட்டது.',
        t279: 'செய்தி வெற்றிகரமாக அனுப்பப்பட்டது.',
        t280: 'மாவட்டத்தை தேர்ந்தெடுக்கவும்',
        t281: 'மாணவர் பெயர் மூலம் தேடவும்',
        t282: 'பதிவேற்று',
        t283: 'பொருத்து',
        t284: '2 மாணவர்களைத் தேர்ந்தெடுக்க வேண்டும்.',
        t285: 'ஒவ்வொரு மாணவரும் சேர்க்கப்பட்டுவிட்டனர்.',

        t286: 'தரவைப் பதிவிறக்கவும்',
        t287: 'மாணவர் சீரற்றமயமாக்கல்',
        t288: 'மொழிபெயர்ப்பாளர் கட்டண விவரங்கள்',
        t289: 'ஆசிரியர் தொடர்பு பட்டியல்',
        t290: 'கடிதப் பரிமாற்ற தரவு',
        t291: 'வடிவம்: ',
        t292: 'பதிவிறக்கும் வடிவம்',

        t293: 'பெறுநர் பிரிவு',

        t294: 'மாணவர்களை இணைத்தல். ஒற்றுமையை உருவாக்குதல்.',
        t295: 'டிஜிட்டல் பென்பால் தளம்',
        t296: 'ஒற்றுமையும் புரிந்துணர்வும் வளர்த்தல்.',
        t297: '⁠நல்லிணக்கத்திற்கு உதவும் கரம் என்றால் என்ன?',
        t298: "Bridging Divides என்பது இலங்கை மாணவர்களை மொழி தடைகளுக்கு அப்பால் இணைக்கவும் நல்லிணக்கத்தை ஊக்குவிக்கவும் வடிவமைக்கப்பட்ட டிஜிட்டல் பென்பால் தளமாகும். ஆசிரியர்கள் பாதுகாப்புக்காக அவர்களின் தொடர்புகளை கண்காணிக்கும் போது மாணவர்கள் பென்பால்களைக் கண்டறியலாம், மின்னஞ்சல்களைப் பரிமாறிக் கொள்ளலாம் மற்றும் நட்பை உருவாக்கலாம். மாணவர்கள் சிங்களம் மற்றும் தமிழில் தடையின்றி தொடர்புகொள்வதற்கு உதவும் மொழிபெயர்ப்பாளர்கள், ஒற்றுமை மற்றும் புரிதலை ஊக்குவிக்கும் அர்த்தமுள்ள மற்றும் உள்ளடக்கிய உரையாடல்களை உறுதி செய்யும் மொழிபெயர்ப்பாளர்களையும் இந்த மேடையில் கொண்டுள்ளது.",
        t299: 'ஏற்கனவே பங்கேற்பாளரா?',
        t300: 'கருவிப்பலகையின் சிறப்பம்சங்கள்',
        t301: 'பாடசாலை கூட்டாளர்கள்',
        t302: 'மொத்த பாடசாலைகள்:',
        t303: 'மொத்த மாணவர்கள்:',
        t304: 'மொத்த ஆசிரியர்கள்:',
        t305: 'திட்டத்தின் நிபுணர்களை சந்தியுங்கள்',
        t306: 'எங்கள் ஆதரவாளர்கள் & கூட்டாளர்கள்',
        t307: 'பயணத்தை காணவும்',
        t308: 'பங்கேற்கும் பாடசாலைகள்',
        t309: 'மேற்கு மாகாணம்:',
        t310: 'கிழக்கு மாகாணம்:',
        t311: 'வட மாகாணம்:',
        t312: 'தெற்கு மாகாணம்:',
        t313: 'மத்திய மாகாணம்:',
        t314: 'வடமத்திய மாகாணம்:',
        t315: 'வடமேற்கு மாகாணம்:',
        t316: 'ஊவா மாகாணம்:',
        t317: 'சப்ரகமுவ மாகாணம்:',
        t318: 'மாணவர்கள்',
        t319: 'பரிமாறப்பட்ட கடிதங்கள்',
        t320: 'அனுப்பிய மொத்த கடிதங்கள்:',
        t321: 'ஒரு கடிதத்திற்கான சராசரி சொல் எண்ணிக்கை:',
        t322: 'மொத்த மொழிபெயர்க்கப்பட்ட சொற்கள்:',
        t323: 'சொற்கள்',
        t324: 'உணர்ச்சி மதிப்பெண்கள்',
        t325: 'நேர்மறை',
        t326: 'எதிர்மறை',
        t327: 'நடுநிலை',
        t328: 'தொடர்பு கொள்ளவும்',
        t329: 'தனியுரிமைக் கொள்கை',
        t330: 'விதிமுறைகள்',
        t331: 'மாணவர்களை இணைத்தல்,',
        t332: 'ஒரு நேரம் ஒரு கடிதம்',
        t333: 'நட்பை வளர்க்கும் டிஜிட்டல் பேன்பால் மேடையொன்று,',
        t334: 'இலங்கையில் மாணவர்களிடையே புரிந்துகொள்ளல் மற்றும் ஒற்றுமையை உருவாக்குகிறது.',
        t335: 'நல்லிணக்கத்திற்கு உதவும் கரம் பற்றி',
        t336: "நல்லிணக்கத்திற்கு உதவும் கரம் இல், உண்மையான தொடர்புகள் மூலம் தடைகளை உடைக்க முடியும் என்றும், ஒருமித்த எதிர்காலத்தை உருவாக்கலாம் என்றும் நாங்கள் நம்புகிறோம். எங்கள் தளமானது இலங்கையின் தமிழ் மற்றும் சிங்கள மாணவர்களுகிடையில் நட்பு, புரிந்துகொள்ளல், மற்றும் ஒத்துழைப்பை ஊக்குவிக்கும் ஒரு டிஜிட்டல் பேன்பால் திட்டமாகும். கடிதங்கள் பரிமாறுவதன் மூலம், மாணவர்கள் தங்கள் சிந்தனைகள், அனுபவங்கள், மற்றும் பண்பாட்டுப் பண்புகளை பாதுகாப்பான மற்றும் கட்டுப்படுத்தப்பட்ட சூழலில் பகிரலாம். திறந்த உரையாடல்களில் ஈடுபடுவதன் மூலம், தவறான புரிதல்களை குறைத்து, மாணவர்கள் பரஸ்பர நுண்ணுணர்வை வளர்த்துக் கொள்வதுடன், புவியியல் மற்றும் இன வேறுபாடுகளை கடந்து நீடித்த உறவுகளை உருவாக்கலாம்.",
        t337: "எங்கள் மேடையில் மொழிபெயர்ப்பு, உணர்ச்சி பகுப்பாய்வு, மற்றும் ஆராய்ச்சியாளர்களின் கருத்துக்களை ஒருங்கிணைத்து, கலாச்சாரங்களுக்கு இடையேயான தொடர்பை மேம்படுத்த உதவுவதுடன் நேர்மறையான சமூக தாக்கமும் கண்காணிக்கப்படுகிறது. கல்வியாளர்கள், ஆராய்ச்சியாளர்கள், மற்றும் கூட்டாளர் அமைப்புகளின் ஆதரவுடன், ஒற்றுமை மற்றும் பரஸ்பர மரியாதையை மதிக்கும் தலைமுறையொன்றை உருவாக்க நாங்கள் முயற்சிக்கிறோம்.",
        t338: "ஒற்றுமையான இணைந்த இலங்கையை உருவாக்க எங்களுடன் இணைந்துகொள்ளுங்கள், ஒரு கடிதத்தால் மாற்றத்தை ஏற்படுத்தலாம்.",
        t339: "ஆதரவு",
        t340: "எங்கள் செய்திமடலுக்கு பதிவு செய்யுங்கள்",
        t341: "எங்கள் தயாரிப்பு பற்றிய செய்திகளையும் புதுப்பிப்புகளையும்",
        t342: "அறிந்து கொள்ள விரும்புகிறீர்களா? பதிவு செய்யுங்கள்.",
        t343: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
        t344: "எங்கள் செய்திமடலுக்கு பதிவு செய்வதன் மூலம், நீங்கள் தனியுரிமைக்",
        t345: "கொள்கைக்கு உடன்படுவீர்கள் மற்றும் வணிக தகவல்களை பெறுவீர்கள்.",
        t346: "⁠நல்லிணக்கத்திற்கு உதவும் கரம்.",
        t347: "கணக்கு உறுதிப்படுத்தபடவில்லை. உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்ட இணைப்பைக் கிளிக் செய்வதன் மூலம் முதலில் அதைச் உறுதிப்படுத்தவும்.",
        t348: "இந்த வகுப்பிற்கு ஏற்கனவே ஒரு ஆசிரியர் பதிவு செய்துள்ளார். பதிவு தோல்வியடைந்தது.",
        t349: "பாவனையாளர் பதிவு செய்யப்படவில்லை",
        t350: "நிராகரி",
        t351: "முன் அனுப்பு",
        t352: "பொருந்தாத மாணவர்கள்",
        t353: "ஆசிரியராக உள்நுழைதல்",
        t354: "மாணவராக உள்நுழைதல்",
        t355: "ஆராய்ச்சியாளராக உள்நுழைதல்",
        t356: "மொழிபெயர்ப்பாளராக உள்நுழைதல்",
        t357: "ஆசிரியராகப் பதிவுசெய்தல்",
        t358: "மாணவராகப் பதிவுசெய்தல்",
        t359: "ஆராய்ச்சியாளராகப் பதிவுசெய்தல்",
        t360: "மொழிபெயர்ப்பாளராகப் பதிவுசெய்தல்",
        t361: "இனம்",
        t362: 'ஒரு இனத்தை தேர்ந்தெடுக்கவும்',

        t363: "உங்கள் தனியுரிமை, எங்களின் முன்னுரிமை",
        t364: "⁠நல்லிணக்கத்திற்கு உதவும் கரம் இல், நாங்கள் உங்களின் தனிப்பட்ட தகவலைப் பாதுகாப்பதற்கும் பராமரிப்பதற்கும் உறுதியாகக் செயல்படுகிறோம். இந்த கொள்கை நாங்கள் உங்கள் தரவை எவ்வாறு சேகரிக்கிறோம், பயன்படுத்துகிறோம், மற்றும் பாதுகாக்கிறோம் என்பதை விளக்குகிறது.",
        t365: "நாங்கள் சேகரிக்கும் தகவல்",
        t366: "பாதுகாப்பான மற்றும் பயனுள்ள அனுபவத்தை வழங்க, நாங்கள் சேகரிப்பவை:",
        t367: "உங்கள் பெயர், வயது மற்றும் பாடசாலை விவரங்கள் (சரிபார்ப்பதற்கு).",
        t368: "நீங்கள் விரும்பும் மொழி (பேன்பால் இணைக்கும் செயற்கூறுக்காக).",
        t369: "தளத்தில் பரிமாறப்படும் மின்னஞ்சல்கள் (பாதுகாப்புக்காக ஆசிரியர்கள் மற்றும் மொழிபெயர்ப்பாளர்கள் மூலம் கண்காணிக்கப்படுகின்றன).",
        t370: "உங்கள் தகவலை எவ்வாறு பயன்படுத்துகிறோம்",
        t371: "பொருத்தமான பேன்பாலை இணைத்து தகவல் பரிமாற.",
        t372: "மொழி தடைகள் இல்லாமல் உரையாடல்களை மேற்கொள்வதற்கு மொழிபெயர்ப்பு வசதியளிக்க.",
        t373: "ஆசிரியர்கள் உரையாடல்களை கண்காணித்து பாதுகாப்பான சூழலை பராமரிக்க",
        t374: "தரவு பாதுகாப்பு",
        t375: "உங்கள் தனிப்பட்ட தகவலை நாங்கள் வேறு தரப்புகளுடன் பகிர்வதில்லை",
        t376: "உங்கள் செய்திகளை உங்களின் பேன்பால், நியமிக்கப்பட்ட ஆசிரியர்கள் மற்றும் மொழிபெயர்ப்பாளர்கள் மட்டுமே காண முடியும்",
        t377: "அனைத்து தரவும் பாதுகாப்பாகச் சேமிக்கப்பட்டுள்ளன; அனுமதி பெற்ற நபர்கள் மட்டுமே அணுகலாம்.",
        t378: "உங்கள் உரிமைகள்",
        t379: "உங்களுக்கு எப்போது வேண்டுமானாலும் உங்கள் கணக்கை நீக்கிக்கொள்ள அனுமதி இருக்கிறது.",
        t380: "உங்களின் தனியுரிமை தொடர்பான ஏதேனும் சந்தேகங்கள் இருப்பின், bddivides@gmail.com என்ற முகவரிக்கு தொடர்புகொள்ளவும்.",

        t381: "உதவி தேவையா? நாங்கள் உதவ தயாராக இருக்கிறோம்!",
        t382: "⁠நல்லிணக்கத்திற்கு உதவும் கரம் இல், உங்களின் அனுபவம் இலகுவாக, பாதுகாப்பாக மற்றும் மகிழ்ச்சியாக அமைய நாங்கள் உறுதியாக செயல்படுகிறோம். உதவி தேவைப்பட்டால், தயவுசெய்து எங்களைத் தொடர்பு கொள்ளவும்.",
        t383: "எப்படித் தொடர்பு கொள்வது",
        t384: "மின்னஞ்சல் ஆதரவு:",
        t385: " bddivides@gmail.com – பிரச்சினைகள், கேள்விகள் அல்லது கருத்துகளுக்காக எங்களை தொடர்பு கொள்ளவும்.",
        t386: "தொலைபேசி ஆதரவு:",
        t387: "0771482755 – அவசர தேவைகளில் அழைக்கவும்.",
        t388: "எங்களால் உதவி செய்யக்கூடிய பொதுப் பிரச்சினைகள்",
        t389: "கணக்கு பதிவு மற்றும் உள்நுழைவு பிரச்சினைகள்",
        t390: "Penpal அல்லது ஆசிரியர் இணைப்பு",
        t391: "முறைகேடான நடத்தை அல்லது தொழில்நுட்ப பிரச்சினைகளை அறிவித்தல்",
        t392: "மொழிபெயர்ப்புகள் எவ்வாறு செயல்படுகிறது என்பதைப் புரிந்துகொள்வது",
        t393: "பங்கேற்பாளர்களுக்கு தொடர் உதவிகளையும் உகந்த கற்கும் சூழலையும் வழங்க நாங்கள் உறுதியாக செயல்படுகிறோம்.",

        t394: "⁠நல்லிணக்கத்திற்கு உதவும் கரம் இல் பதிவுசெய்வதன் மூலம், நீங்கள் பின்வரும் விதிமுறைகளை ஒப்புக்கொள்கிறீர்கள்:",
        t395: "1. தகுதி",
        t396: "இந்த திட்டத்தில் சேர்ந்துள்ள பங்கேற்பாளர்களுக்கு மட்டுமே பதிவு செய்ய முடியும். அனுமதியற்ற பதிவுகள் தடை செய்யப்பட்டுள்ளது. பாதுகாப்பான மற்றும் ஒழுங்கமைக்கப்பட்ட அனுபவத்தை உறுதிப்படுத்த பயனர்கள் சரியான தகவலை வழங்க வேண்டும்.",
        t397: "2. பயனர் பொறுப்புகள்",
        t398: "நீங்கள் உங்கள் penpal-களுடன் மரியாதையுடனும் நல்ல ஒழுக்கத்துடனும் உரையாடுவீர்கள். செய்திகள் நல்லிணக்கமும் நட்பையும் ஊக்குவிக்கும் வகையிலேயே இருக்க வேண்டும். பாதுகாப்பிற்காக தளத்திற்கு வெளியே தனிப்பட்ட தொடர்பு விவரங்களை பகிரக்கூடாது.",
        t399: "3. கண்காணிப்பு மற்றும் மேற்பார்வை",
        t400: "ஆசிரியர்கள் மற்றும் மொழிபெயர்ப்பாளர்கள் பாதுகாப்பான மற்றும் பயனுள்ள தொடர்பை உறுதி செய்வதற்காக செய்திகளை மிதமான அளவில் கண்காணிப்பதற்கு அனுமதி பெற்றுள்ளனர். தவறான, தாக்கம் அதிகமான அல்லது ஆபத்தான உரையாடல்கள் உடனடியாக பரிசீலிக்கப்பட்டு திட்டத்திலிருந்து நீக்கப்படலாம்.",
        t401: "4. தனியுரிமை மற்றும் தரவு பாதுகாப்பு",
        t402: "பயனர்கள் வழங்கும் தகவல்கள் பாதுகாப்பாக வைக்கப்படுகின்றன; வேறு தரப்புகளுடன் பகிரப்படாது.",
        t403: "மேலும் விவரங்களுக்கு, எங்களது தனியுரிமை கொள்கையை பார்க்கவும். பதிவைத் தொடர்வதன் மூலம், இவ்விதிமுறைகளை ஏற்றுக்கொள்வதுடன் அதன் மீறல் உங்களின் கணக்கை நிறுத்துவதற்கும் நீக்குவதற்கும் வழிவகுக்கும் என்பதை வலியுறுத்துகிறோம்.",

        t404: "பொருந்திய மாணவர்கள்",
        t405: "உங்களுக்கு இன்னும் penpal தெரிவு செய்யப்படவில்லை",
        t406: "மின்னஞ்சல்: ",
        t407: "தொலைபேசி: ",
        t408: "வரைவுச் செய்தி நீக்கப்பட்டது.",
        t409: "தற்போது ஒரு மொழிபெயர்ப்பாளர் இதை மேற்பார்வையிடுகிறார்.",
        t410: "கருவிப்பலகை",
        t411: "உங்கள் அஞ்சல்கள்",
        t412: "தகவல் அறிய கிளிக் செய்யவும்",
        t413: "(மாணவனின்/மாணவியின் தகவலை பார்க்க அவரை கிளிக் செய்யவும்)",
        t414: "அதே மின்னஞ்சலுடன் ஏற்கனவே ஒரு பயனர் காணப்பட்டுள்ளார்.",
        t415: "செயலில் உள்ள மாணவர்கள்",
        t416: "தேவையான மொழி",
        t417: "ஒன்றுமில்லை",
        t418: "குழு",
        t419: "ஒரு குழுவை தேர்ந்தெடுக்கவும்",
        t420: "நிலுவையில் உள்ளவை",
        t421: "மொழிபெயர்ப்பாளர் விவரங்கள்",
        t422: "வங்கி விவரங்கள்",
        t423: 'இந்த நடவடிக்கை இந்த மொழிபெயர்ப்பாளர் கணக்கை நிரந்தரமாக நீக்கும். தயவுசெய்து உறுதிப்படுத்தவும்.',

        t424: 'மொழிபெயர்ப்பாளர்/ ஆராய்ச்சியாளர் விவரங்கள்',
        t425: 'ஆராய்ச்சியாளர் விவரங்கள்',

        t426: "பதில் எழுதுங்கள்",
        t427: "பதிலை அனுப்புங்கள்",
        t428: "அஞ்சலிற்கான மொழி",
        t429: "மாணவர்களை அனுமதிக்கவும்",
        t430: "பாடசாலைகளை ஒதுக்குதல்",
        t431: "பாடசாலைகள் எதுவும் இல்லை",
        t432: "ஆராய்ச்சியாளர்கள் யாருமில்லை",
        t433: "மற்றையவை",
        t434: "அனுப்பியவர்",
        t435: "ஸ்கேன் செய்யவும்",
        t436: "புகைப்படம் எடுக்கவும்",
        t437: "பிடிக்கவும்",
        t438: "இந்த வாரத்தில் நீங்கள் ஏற்கனவே பேனா நண்பனுக்கு 3 மின்னஞ்சல்கள் அனுப்பியுள்ளீர்கள். மேலும் செய்திகளை அனுப்ப அடுத்த வாரம் வரை காத்திருக்கவும்.",
        t439: "மொழிபெயர்க்கப்பட்ட மின்னஞ்சல்களை பதிவிறக்கவும்",
        t440: "இதுவரை எந்த மின்னஞ்சலும் மொழிபெயர்க்கப்படவில்லை",
        t441: "மின்னஞ்சல் அல்லது பயனர் பெயர்",
        t442: "மின்னஞ்சல் அல்லது பயனர் பெயர் தேவை",
        t443: "தவறான மின்னஞ்சல் அல்லது பயனர் பெயர்.",
        t444: "இது மின்னஞ்சல் என்றால், வடிவம் test@example.com போல இருக்க வேண்டும்.",
        t445: "பயனர் பெயர் குறைந்தபட்சம் 7 எழுத்துகள் கொண்டதாகவும், எழுத்துகள் மற்றும் எண்கள் மட்டுமே உள்ளதாகவும் இருக்க வேண்டும்",
        t446: "ஆரம்பிப்போம்",
        t447: "செயற்காட்சி",
        t448: "Please select your preferred language to continue. You can always change it later using options in top right corner.",
        t449: "தயவுசெய்து வீடியோவை பார்ப்பதற்கான உங்கள் விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்.",
        t450: "நீங்கள் <bold>ஏற்கனவே பதிவு செய்திருந்தால்</bold>, உள்நுழைய <bold>'ஆம்'</bold> என்பதை அழுத்தவும்.",
        t451: "இது உங்கள் <bold>முதல் முறையெனில்</bold>, புதிய கணக்கை பதிவு செய்ய <bold>'இல்லை'</bold> என்பதை அழுத்தவும்.",
        t452: "தனிப்பட்ட விவரங்கள்",
        t453: "கடவுச்சொல் விவரங்கள்",
        t454: "மற்றைய விவரங்கள்",
        t455: "பின் செல்க",
        t456: "அஞ்சல்கள் எதுவும் இல்லை",
        t457: "வாசிக்கப்படாதவை",
        t458: "படி 1",
        t459: "படி 2",
        t460: "மாணவர்களை பதிவேற்றவும் அல்லது கீழே இருந்து தேர்ந்தெடுக்கவும்.",
        t461: "ஒரே மொழியில் பேசும் மாணவர்களுக்கு Treat ஐ தேர்வுசெய்க, அல்லது மாறுபட்ட மொழியுள்ள மாணவர்களுக்கு Control ஐ தேர்வுசெய்க. பின்னர் அவர்களை இணைக்க Match ஐ கிளிக் செய்க.",
        t462: "Excel sheet இன் வடிவமைப்பு",
        t463: "முதல் column மாணவரின் email/username ஆக இருக்க வேண்டும்.",
        t464: "இரண்டாவது column penpal இன் email/username ஆக இருக்க வேண்டும்.",
        t465: "column-களுக்கு தலைப்புகள் எழுத வேண்டாம்.",
        t466: "மூன்றாவது column group ஆக இருக்க வேண்டும் (CONTROL அல்லது TREATMENT எனப்பட வேண்டும்).",
        t467: "தயவுசெய்து உங்கள் மின்னஞ்சல் மற்றும் கடவுச்சொல்லை உள்ளிடவும்.",
        t468: "தயவுசெய்து உங்கள் மின்னஞ்சல் அல்லது பயனர் பெயர் மற்றும் கடவுச்சொல்லை உள்ளிடவும்.",
        t469: "ஒரு மின்னஞ்சலுக்கு வார்த்தை வரம்பு 500 வார்த்தைகள் ஆகும்.",
        t470: "உங்கள் செய்தியைத் தொடங்குங்கள் ✉️",
        t471: "புதிய மின்னஞ்சலை வலதுபுற பெட்டியில் எழுதுங்கள்.",
        t472: "வணக்கம் சொல்லுங்கள், உங்கள் கதையைப் பகிருங்கள், அல்லது ஒரு கேள்வி கேளுங்கள் – உங்கள் நண்பர் உங்களிடம் இருந்து கேட்கக் காத்திருக்கிறார்!",
        t473: "செய்திகள்",
        t474: "உங்கள் கணக்கில் உள்நுழைவதற்கு உங்கள் பாத்திரத்தை (மாணவர், ஆசிரியர், மொழிபெயர்ப்பாளர் அல்லது ஆராய்ச்சியாளர்) தேர்வு செய்யவும்.",
        t475: "உங்கள் கணக்கை உருவாக்க உங்கள் பாத்திரத்தை (மாணவர், ஆசிரியர், மொழிபெயர்ப்பாளர் அல்லது ஆராய்ச்சியாளர்) தேர்வு செய்யவும்.",
        t476: "இணை",
        t477: "OCR",
      },
    },
    si: {
      translation: {

        t1: "සංහිඳියාවට අත්වැළක්",
        t2: "ඔබ පුරනය වන්නේ කවුරුන් ලෙස ද?",
        t2_2: "ඔබ පෙර සාදන ලද ගිණුමට ඇතුලුවීමට පහත ලැයිස්තුවෙන් ඔබ කවුරුන් දැයි තෝරන්න.",
        t3: "ගුරුවරයා",
        t4: "ශිෂ්‍යා",
        t5: "පරිවර්තක",
        t6: "ගවේෂක",
        t7: "ඉදිරියට යන්න",
        t8: "ගිණුමක් නැද්ද?",
        t8_2: 'ඔබට පෙර සාදන ගිණුමක් තිබේද?',
        t9: "නව ගිණුමක් සාදන්න",
        t9_2: "නව ගිණුමක් සෑදීම සදහා භූමිකාව තෝරන්න",
        t10: "කරුණාකර ඉදිරියට යාමට කාණ්ඩයක් තෝරාගන්න",
        t11: "හරි",
        t12: "ප්‍රතික්ෂේප කරන්න",
        t13: "පිටවන්න",
        /* loginpage 2 */
        t14: " විද්‍යුත් තැපෑල",
        t14_1: " විද්‍යුත් තැපැල්",
        t15: " විද්‍යුත් තැපෑල අවශ්‍ය වේ",
        t16: "වලංගු විද්‍යුත් තැපෑලක් ඇතුළත් කරන්න",
        t17: "මුරපදය",
        t18: "මුරපදය අවශ්‍ය වේ",
        t19: "මුරපදය අවම වශයෙන් අකුරු 8 කින් සමන්විත විය යුතුය",
        t20: "මුරපදය අමතක වුණාද?",
        t20_1: "ඔබගේ මුරපදය අමතක වුණාද?",
        t20_2: " එය නැවත සකසන්න",
        t21: "ඇතුළුවන්න",
        t22: "මම ඊළඟ වතාවේ ඇතුලු වෙනකොට මගේ විස්තර මතක තියාගන්න.",
        /* createnewaccountcommon */
        t23: "ඔබ කවුරුන් ලෙස ලියාපදිංචි වන්නේ ද?",
        t24: " දැනටමත් ගිණුමක් තිබේ ද ?",
        t25: " පුරන්න",
        t26: "මුරපදය ගැලපෙන්නේ නැත",
        t27: " සම්පූර්ණ නම",
        t28: " වලංගු නමක් ඇතුළත් කරන්න ",
        t29: " සම්පූර්ණ නම අවශ්‍යයි",
        t30: "මුරපදය තහවුරු කරන්න",
        /* StudentSignUp2*/
        t31: " කැමති භාෂාව",
        t32: "භාෂාවක් තෝරන්න",
        t33: "පාසල",
        t33_1: "පාසල්",
        t34: "පාසලක් තෝරන්න",
        t35: " ශ්‍රේණිය",
        t36: " ශ්‍රේණියක් තෝරන්න",
        t37: "පන්තිය",
        t38: "පන්තියක් තෝරන්න",
        t39: "ගුරුවරයෙකු තෝරන්න",
        /* StudentSignUp3*/
        t40_1: "ඔබ ගැන හැඳින්වීමක් කරන්න",
        t40_2: " කරුණාකර අවම වශයෙන් 1 විනෝදාංශයක් ඇතුළත් කරන්න",
        t40_3: " කරුණාකර අවම වශයෙන් 1 ක්‍රීඩාවක් ඇතුළත් කරන්න",
        t40_4: " කරුණාකර අවම වශයෙන් 1 චිත්‍රපටියක් ඇතුළත් කරන්න",
        t40_5: " කරුණාකර අවම වශයෙන් 1 නළුවෙක් ඇතුළත් කරන්න",
        t40_6: " කරුණාකර ඔබ ගැන කියන්න",
        t40_7: " විනෝදාංශ",
        t40_8: "චිත්‍රපට",
        t40_9: "නළුවන්",
        t40_10: "ක්‍රීඩා",
        t40_11: "උපරිම 2 ටයිප් කිරීමෙන් පසු ඇතුල් කරන්න",
        t40: " ස්ත්‍රී පුරුෂ භාවය තෝරන්න",
        t41: "උපන් දිනය",
        t42: "ඔබගේ උපන් දිනය තෝරන්න",
        t43: "ස්ත්‍රී පුරුෂ භාවය ",
        t44: "පුද්ගලික රුචීන්",
        t45: "ඔබගේ පුද්ගලික රුචීන් විස්තර කරන්න",
        t46: "මම මෙහි ඇති නියමයන් සහ කොන්දේසි සියල්ල කියවා පිළිගතිමි",
        t47: "කරුණාකර කොන්දේසි වලට එකඟ වන්න",
        t48: "අවධානය දෙන්න",
        t49: "නියමයන් සහ කොන්දේසි මගින්, පාර්ශවයන් දෙක අතර පවතින සම්බන්ධතාවයන් ගැන සහ වෙබ් අඩවිය හෝ සේවාව භාවිතා කරන විට පරිශීලකයා නොකළ යුතු දේ, සහ ව්‍යාපාරය පවත්වාගෙන යන අයිතිවාසිකම් වැනි දෙපාර්ශවයම පිළිපැදිය යුතු කොන්දේසි ඇතුළත් වේ",
        t50: "එකඟ වේ",
        t51: "ප්‍රතික්ෂේප කරන්න",
        t52: "ඇතුළත් කරන්න",
        t53: "නියම සහ කොන්දේසි",
        t54: "ඔබගේ ගිණුම සාර්ථකව සාදන ලදි. සත්‍යාපනය සඳහා කරුණාකර ඔබගේ විද්‍යුත් තැපෑල පරීක්ෂා කරන්න.",
        t54_1: 'ඔබගේ ගිණුම සාර්ථකව නිර්මාණය කර ඇත. කරුණාකර ඉදිරියට යාමට ලොග් වන්න.',
        t54_2: 'ඔබගේ ගිණුම සාර්ථකව නිර්මාණය කර ඇත. කරුණාකර ගුරුවරයාගේ අනුමැතිය සඳහා රැඳී සිටින්න.',
        /* teacherSignUp2*/
        t55: "දිස්ත්‍රික්කය",
        t56: "දිස්ත්‍රික්කයක් තෝරන්න",
        t57: "ජංගම දුරකථන අංකය (07xxxxxxxx)",
        t58: "ජංගම දුරකථන අංකයක් අවශ්‍යයි",
        t59: " වලංගු ජංගම දුරකථන අංකයක් ඇතුලත් කරන්න",
        /*password check */
        t60: "මුරපදයේ අවම වශයෙන් ඉංග්‍රීසි හෝඩියේ capital (කැපිටල්) අක්ෂර 1ක් වත් අඩංගු විය යුතුය",
        t61: "මුරපදයේ අවම වශයෙන් ඉංග්‍රීසි හෝඩියේ simple (සිම්පල්) අක්ෂර 1ක් වත් අඩංගු විය යුතුය",
        t62: "මුරපදයේ අවම වශයෙන් සංඛ්‍යා 1ක් වත් අඩංගු විය යුතුය ",
        t63: " මුරපදයේ අවම වශයෙන් විශේෂ සලකුණු 1ක් වත් අඩංගු විය යුතුය(@,#..)",
        t64: "මුරපදයේ දිග 8 අකුරු වඩා වැඩි විය යුතුය",
        t65: "මුරපද ශක්තිය : ",
        t66: "දුර්වල",
        t67: "මධ්‍යම",
        t68: " ශක්තිමත්",
        /* forgot password page 1 */
        t69: "මුරපදය අමතක වුණා ද?",
        t70: "Link එවන්න",
        t71: "OTP ඇතුල් කරන්න",
        t72: "ඔබේ විද්‍යුත් තැපැල් ගිණුමට එවූ OTP ඇතුල් කරන්න",
        t73: " නැවත OTP එවන්න",
        t74: "ඔබගේ ගිණුමේ විද්‍යුත් තැපෑල ඇතුල් කරන්න",
        t74_1: "ඔබගේ විද්‍යුත් තැපැල් ලිපිනය ඇතුළත් කරන්න. ඔබගේ මුරපදය නැවත සැකසීමට අපි ඔබට සබැඳියක් එවන්නෙමු.",
        t75: "තහවුරු කරන්න",
        t76: "ඔබේ නව මුරපදය සකසන්න",
        t78: "ඔබගේ ගිණුමේ මුරපදය සාර්ථකව වෙනස් විය",
        t78_1: "ගිණුමේ මුරපදය සාර්ථකව වෙනස් විය",
        // t: "ඔබගේ ගිණුම සාර්ථකව සාදන ලදි", (not in the English translation)
        t79: "ආයුබෝවන්, ",
        t80: "සම්බන්ධ වන්න. හුවමාරු කරගන්න. දිරිගන්වන්න.",
        t81: "නව සබඳතා ඇති කරගෙන ඔබේ කතා සහ අදහස් හුවමාරු කරගැනීමට සූදානම්ද? ඔබගේ පෑනේ මිතුරා සමඟ සම්බන්ධ වීමට උපකරණ පුවරුව වෙත යන්න නව දෘශ්ටිකෝණයන් දැක, වෙනසක් ඇති කිරීමට අද ම මුල පුරන්න!",
        t82: "සබඳතාවයන් ගොඩනගමු, සෑම ලිපියක් පාසා සමගිය ඇති කරමු.",
        /* student signup 3 remaining */
        t83: 'ප්‍රියතම නළුවා',
        t84: 'ප්‍රියතම උපුටා ගත් වාක්‍යය',
        t85: 'ප්‍රියතම විෂයය',
        t86: 'ප්‍රියතම විෂයය ඇතුළත් කරන්න',
        t87: 'ඔබගේ ප්‍රියතම නළුවා කවුද?',
        t88: 'ඔබගේ ප්‍රියතම උපුටා ගත් වාක්‍ය කුමක්ද?',
        t89: 'ඔබ විසින් ඇතුළත් කළ නළුවා වලංගු නොවේ',
        t90: 'ඔබ විසින් ඇතුළත් කළ විෂය වලංගු නොවේ',
        t91: 'ඔබ විසින් ඇතුළත් කළ උපුටා ගත් වාක්‍ය වලංගු නොවේ',
        /* error alert */
        t92: 'මෙම විද්‍යුත් තැපැල්/පරිශීලක නාමය දැනටමත් ලියාපදිංචි කර ඇත. කරුණාකර වෙනත් ලිපිනයක් භාවිතා කරන්න නැතිනම් පුරනය වන්න.',
        t93: 'අන්තර්ජාල සම්බන්ධතාවයක් නොමැත. කරුණාකර ඔබගේ අන්තර්ජාල සබඳතාව පරීක්ෂා කර නැවත උත්සාහ කරන්න.',
        t94: 'දෝෂයක් සිදුවිය. කරුණාකර නැවත උත්සාහ කරන්න.',
        t95: 'දෝෂය',
        t96: 'පිටවන්න',
        /* student signup error alert */
        t97: 'කරුණාකර පළමුව ඔබගේ ගුරුවරයාගෙන් ලියාපදිංචි වන ලෙස ඉල්ලා සිටින්න.',
        /* Empty array dialog */
        t98: 'ඔබේ දිස්ත්‍රික්කයේ ලියාපදිංචි වී ඇති පාසල් කිසිවක් නොමැත. කරුණාකර පළමුව ඔබගේ ගුරුවරයාගෙන් ලියාපදිංචි වන ලෙස ඉල්ලා සිටින්න.',
        /* user login error alert */
        t99: 'කරුණාකර පළමුව ලියාපදිංචි වන්න.',
        t100: 'වලංගු නොවන අගයක් ඇතුළත් කරන ලදි. කරුණාකර නැවත උත්සාහ කරන්න.',
        t101: 'ගිණුම සක්‍රිය නොවේ. කරුණාකර ගුරුවරයාට සක්‍රිය කිරීමට පවසන්න.',
        t102: 'ගිණුම සක්‍රිය නොවේ හෝ වලංගු නොවන අගයක් ඇතුළත් කරන ලදි.',
        /* teacher dashboard */
        t103: 'ඔබගේ සිසුන් සවිබල ගැන්වීම සහ අනාගතයේ නායකයන් පරම්පරාව හැඩගැස්වීමට අනෙකුත් අධ්‍යාපනඥයින් සමඟ සම්බන්ධ වන්න.සෑම පියවරකදීම ඔබට සහාය වීමට අපි මෙහි සිටිමු.',
        t104: 'දළ විශ්ලේෂණය',
        t105: 'ලියාපදිංචි සිසුන්',
        t106: 'අනුමත නොකළ ආරාධනා',
        t107: 'සිසුන් කළමනාකරණය',
        t108: 'ශිෂ්‍ය ක්‍රියාකාරකම්',
        t109: 'පැමිණි පණිවිඩ',
        /* teacher - manage students page */
        t110: 'සිසුන් කළමනාකරණය',
        t111: 'සිසුන්ට ආරාධනා කරන්න',
        t112: 'අයදුම්පත් අනුමත කරන්න',
        t113: 'මුරපද නැවත සැකසීම',
        t113_1: "මුරපදය නැවත සැකසීමේ ඉල්ලීම්",
        t113_2: "ශිෂ්‍ය මුරපද නැවත සකසන්න",
        t114: 'මතක් කිරීමක් යවන්න',
        /* teacher- invite students page */
        t115: 'සිසුවාගේ විද්‍යුත් තැපෑල',
        t116: 'යවන්න',
        t117: 'ආරාධනය සාර්ථකව යවන ලදී',
        t118: 'සිසුවාගේ විද්‍යුත් තැපෑල',
        /* error alert invitation send */
        t119: 'සිසුවා දැනටමත් ලියාපදිංචි වී ඇත',
        t120: 'මෙම සිසුවාට දැනටමත් ආරාධනයක් යවා ඇත',
        /* teacher request select page */
        t121: 'ගිණුම් මකා දැමීමේ ඉල්ලීම්',
        t122: 'ලියාපදිංචි වීමට ඉල්ලීම්',
        /* delete request page */
        t123: 'අනුමත කරන්න',
        t124: 'ප්‍රතික්ෂේප කරන්න',
        t125: "ගිණුම් මකා දැමීමේ 'ඉල්ලීම් කිසිවක් හමු නොවීය'",
        /* teacher approve registration request page */
        t126: 'ඉල්ලීම් කිසිවක් හමු නොවීය',
        /*teacher send reset password link page */
        t127: 'මුරපද නැවත සැකසීමේ සබැඳිය සාර්ථකව යවන ලදී',
        t127_2: 'ආරාධනය සාර්ථකව යවන ලදී',
        t127_3: 'ඔබට ලියාපදිංචි වීමට අවසර නැත.',
        t128: 'සිසුවා ලියාපදිංචි වී නොමැත.',
        /* class details page teacher */
        t129: 'බාගැනීම සාර්ථකයි',
        t130: 'සියල්ල',
        t131: 'සක්‍රීය',
        t132: 'අක්‍රීය',
        t131_1: 'සක්‍රීය',
        t132_1: 'අක්‍රීය',
        t133: 'බාගන්න',
        t134: 'බාගත කිරීමට දත්ත කිසිවක් හමු නොවීය',
        t135: 'සිසුන් කිසිවකු හමු නොවීය',
        t136: 'සිසුවාගේ නම',
        t137: 'පසුගිය සතියේ ක්‍රියාකාරකම්',
        t138: 'තත්ත්වය',
        /* teacherview student detail */
        t139: 'සිසුවාගේ විස්තර',
        t140: 'තත්ත්වය සැකසීම',
        t141: 'මකන්න',
        t142: 'සාර්ථකව යාවත්කාලීන කර ඇත',
        t143: 'මෙම ක්‍රියාව සිසුවාගේ ගිණුම ස්ථිරව මකා දමනු ඇත. කරුණාකර තහවුරු කරන්න',
        t143_2: 'මෙම ක්‍රියාව ගුරුවරුන්ගේ ගිණුම ස්ථිරව මකා දමනු ඇත. කරුණාකර තහවුරු කරන්න',
        t144: 'තහවුරු කරන්න',
        t145: 'අවලංගු කරන්න',
        t146: 'යාවත්කාලීන කරන්න',
        /* teacher profile page */
        t147: 'ඔබගේ ගිණුම',
        t147_2: 'විස්තර',
        t148: ' විද්‍යුත් තැපෑල',
        t149: 'දිස්ත්‍රික්කය',
        t150: 'පාසල',
        t151: 'ශ්‍රේණිය',
        t152: 'පන්තිය',
        t152_2: 'පුද්ගලික රුචීන්',
        t152_3: 'බැංකු ගිණුමේ නම',
        t152_4: 'ඇමතීමට තොරතුරු',
        t152_5: 'බැංකු ගිණුමේ අංකය',
        t152_6: 'බැංකුවේ නම',
        t152_7: 'බැංකු ශාඛාවේ නම',
        /* teacher setting page */
        t153: 'සැකසුම්',
        t154: 'ගිණුම සංස්කරණය කරන්න',
        t155: 'මුරපදය වෙනස් කරන්න',
        t156: 'උදව් සහ සහාය',
        t157: 'පුද්ගලිකත්ව ප්‍රතිපත්ති',
        t158: 'ගිණුම මකාදමන්න',
        t159: 'පිටවීම',
        t160: 'මෙම ක්‍රියාව ඔබේ ගිණුම ස්ථිරවම මකා දමනු ඇත. කරුණාකර තහවුරු කරන්න',
        t160_1: "මකා දැමීමේ ඉල්ලීම ගුරුවරයාට යවනු ඇත. ගුරුවරයා ඉල්ලීම පිළිගත් විට ගිණුම මකාදැමෙනු ඇත.",
        t161: 'මෙම ක්‍රියාව ඔබේ ගිණුමෙන් පිටවීමට හේතු වනු ඇත. කරුණාකර තහවුරු කරන්න',
        /* teacher change password page */
        t162: 'මුරපදය වෙනස් කරන්න',
        t163: 'මෙය ඔබේ මුරපදය වෙනස් කරනු ඇත. කරුණාකර තහවුරු කරන්න',
        t164: 'මුරපදය සාර්ථකව වෙනස් විය.',
        /* teacher update details page */
        t165: 'විස්තර සාර්ථකව යාවත්කාලීන කරන ලදී.',
        t166: 'මෙය ඔබේ විස්තර යාවත්කාලීන කරනු ඇත. කරුණාකර තහවුරු කරන්න',
        /* student profile */
        t167: ' විනෝදාංශ:',
        t168: 'ක්‍රීඩා:',
        t169: 'නළුවන්:',
        t170: 'චිත්‍රපට:',
        /* penpal profile */
        t171: " පෑනේ මිතුරාගේ ගිණුම",
        t172: 'පණිවිඩය',
        t172_2: 'පණිවිඩයක් යවන්න',
        /* student edit profile */
        t173: " ගොනු විශාලත්වය 1MB ට වඩා අඩු බව සහතික කර ගන්න.",
        t174: "රූපය අපේක්ෂිත ප්‍රමාණයට වඩා විශාලයි. රූපය 1MB ට අඩු විය යුතුය.",
        t174_2: "රූපය සමචතුරස්‍රාකාර විය යුතුය (පළල සහ උස සමාන විය යුතුය).",
        /* translator greeting */
        t175: "සිසුන් අතර සන්නිවේදනය සහ අවබෝධය වර්ධනය කිරීම සඳහා ඔබේ කාර්යභාරය ඉතා වැදගත් වේ. අර්ථවත් සම්බන්ධතා ගොඩනැගීමට ඔබ දැක්වූ සහයෝගයට ස්තූතියි!",
        /* translator dashboard */
        t176: 'පොරොත්තුවෙන්',
        t177: 'පරිවර්තනය කර ඇත',
        t178: 'තැපෑල් පරිවර්තනය කර අර්ථය මධ්‍යස්ථ කරන්න',
        t179: 'පෙර ක්‍රියාකාරකම්වල වාර්තාව',
        t180: 'දැනුම්දීම්',
        /* researcher dashboard */
        t181: 'පරිවර්තන',
        t182: 'ප්‍රතිකාර',
        t183: 'පාලන සැකසුම්',
        t184: 'ගුරු මණ්ඩලය',
        t185: 'පරිවර්තකයන්',
        t186: 'ශිෂ්‍යයන්',
        t187: 'සංවාද (අද)',
        t188: 'මෙම සතියේ පරිවර්තන',
        t189: 'ප්‍රතික්ෂේප කළා',
        t190: 'පොරොත්තු සංවාද',
        t191: 'දත්ත කළමනාකරණය',
        t192: 'ආරාධනා කළමනාකරණය',
        t193: 'පැනේ මිතුරන් ගැලපුම්',
        t194: 'මුරපද යළි සැකසීම',
        t195: 'ශිෂ්‍ය සහභාගීත්වය',
        t195_2: 'දත්ත බාගන්න',
        t196: 'දැනුම දිරිගැන්වීම සහ සම්බන්ධතා පෝෂණය කිරීම, ඔබගේ තීක්ෂ්ණ බුද්ධිය ඉගෙනීමේ ක්‍රියාවලිය අර්ථවත් ලෙස හැඩගැස්වීමට උපකාරී වේ. පර්යේෂණයේ සෑම පියවරකදීම ඔබට සහාය වීමට අපි මෙහි සිටිමු.!',
        /* researcher view teacher profile */
        t197: 'ගුරු විස්තර',
        /* Researcher manage data */
        t198: 'දිස්ත්‍රික්කය තෝරන්න',
        t199: 'පාසල තෝරන්න',
        t200: 'ගුරුවරයා තෝරන්න',
        t201: 'කරුණාකර ප්‍රථමයෙන් දිස්ත්‍රික්කයක් තෝරන්න',
        t202: 'කරුණාකර ප්‍රථමයෙන් පාසලක් තෝරන්න',
        t203: 'කරුණාකර අවම වශයෙන් එක් විකල්පයක්වත් පුරවන්න',
        t204: 'සොයන්න',
        t205: 'ශිෂ්‍යයන් කිසිවෙක් හමු නොවීය',
        t206: 'ගුරුවරුන් කිසිවෙක් හමු නොවීය',
        t207: 'පෙන්වන්න',
        t208: 'පණිවිඩ පෙන්වන්න',
        t209: 'දෝෂයක් සිදුවිය. පිටුව නැවත refresh කරන්න',
        t210: 'කරුණාකර භූමිකාවක් තෝරන්න',
        t211: 'භූමිකාව',
        t212: 'පාලනය',
        t213: 'ප්‍රතිකාර',
        /* researcher compose mail */
        t214: 'ලබන්නාට ගිණුමක් නොමැත.',
        t215: 'මෙය කටුපිටපතක් ලෙස සුරැකීමට අවශ්‍යද?',
        t216: 'ඔව්',
        t217: 'නැහැ',
        t218: 'තහවුරු කිරීම අවශ්‍යයි',
        t219: 'ලබන්නාගේ ලිපිනය සහ පණිවිඩය හිස්විය නොහැක',
        t220: 'වෙත',
        t221: 'ලබන්නාගේ භූමිකාව තෝරන්න',
        t222: "ලබන්නාගේ විද්‍යුත් තැපෑල ඇතුළත් කරන්න",
        t223: "ලබන්නාගේ විද්‍යුත් තැපෑල අවශ්‍යයි",
        t224: "අත්‍යවශ්‍ය නොවේ",
        t225: "පණිවිඩය",
        t226: "පණිවිඩයක් එක් කිරීම අවශ්‍යයි",
        t227: "ලැබුණු පණිවිඩ",
        t228: "තැපෑල අනුව සොයන්න",
        t229: "දිනය අනුව වර්ග කරන්න",
        t230: " ලැබුණු පණිවිඩ",
        t231: "යවන ලද පණිවිඩ",
        t232: "කටුපිටපත්",
        t233: "ලිපියක් ලියන්න",
        t234: "විද්‍යුත් තැපෑල",
        t235: "යවන්නා",
        t236: "විෂය",
        /* student penpal error */
        t237: " පෑනේ මිතුරෙකු තවම පවරා නැත.",
        t238: "ඉංග්‍රීසි වලින් ටයිප් කරන්න",
        t239: "සිංහලින් ටයිප් කරන්න",
        t240: "දෙමළින් ටයිප් කරන්න",
        t241: "මෙම ශිෂ්‍යයා ඔබේ පන්තියට අයත් නොවේ",
        t242: "ප්‍රතික්ෂේප කරන ලදී",
        /* translator edit profile */
        t243: "බැංකු ගිණුම් නම",
        t244: "බැංකුවේ නම",
        t245: "බැංකු ගිණුම් අංකය",
        t246: "බැංකු ශාඛාව",
        t247: "බැංකු ගිණුම් නම අවශ්‍යයි",
        t248: "බැංකුවේ නම අවශ්‍යයි",
        t249: "බැංකු ගිණුම් අංකය අවශ්‍යයි",
        t250: "බැංකු ශාඛාවේ නම අවශ්‍යයි",
        t251: "වලංගු බැංකු ගිණුම් නමක් ඇතුළත් කරන්න",
        t252: "වලංගු බැංකු නමක් ඇතුළත් කරන්න",
        t253: "වලංගු බැංකු ගිණුම් අංකයක් ඇතුළත් කරන්න",
        t254: "වලංගු බැංකු ශාඛාවේ නමක් ඇතුළත් කරන්න",
        t255: 'එක් සිසුවෙක් හෝ සිසුන් දෙදෙනාම හමු නොවීය ',
        t256: 'විද්‍යුත් තැපෑල හෝ නම මඟින් සොයන්න',
        t257: "සපයන ලද විද්‍යුත් තැපෑල ලියාපදිංචි කර නොමැත",
        /* researcher invitation */
        t258: "පරිශීලකයා දැනටමත් ලියාපදිංචි කර ඇත",
        t259: "පරිශීලකයාට දැනටමත් ආරාධනා කර ඇත",
        t260: 'ප්‍රතිචාරය',
        t261: 'ඉල්ලීම් යැව්වා',
        t262: 'නැවත යවන්න',
        t263: 'ආරාධනය සාර්ථකව යවන ලදී',
        t267: 'ආරාධනා යවන්න',
        t268: 'භූමිකාව:',
        t269: 'භූමිකාවක් තෝරන්න',
        t270: 'යවන ලද ආරාධනා',
        t271: 'කරුණාකර භූමිකාවක් තෝරන්න',
        /*forgot password */
        t272: 'පරිශීලකයා ලියාපදිංචි වී නොමැත.',
        t273: 'කරුණාකර ඔබගේ විද්‍යුත් තැපෑලට ගොස් ඉදිරියට යාමට සබැඳිය ක්ලික් කරන්න.',
        t274: 'ඔබ මුරපදය වෙනස් කිරීමක් ඉල්ලා නැත.',
        t275: 'පණිවිඩය සාර්ථකව යවා ඇත.',
        t276: 'පණිවිඩය සාර්ථකව සුරකින ලදී.',
        t277: 'පණිවිඩය සාර්ථකව පරිවර්තනය විය.',
        t278: 'පණිවිඩය සාර්ථකව ප්‍රතික්ෂේප විය.',
        t279: 'පණිවිඩය සාර්ථකව යොමු කරන ලදී.',
        t280: 'දිස්ත්රික්කය තෝරන්න',
        t281: 'ශිෂ්‍ය නාමයෙන් සොයන්න',

        t282: 'උඩුගත කරන්න',
        t283: 'ගැලපේ',
        t284: 'සිසුන් 2 දෙනෙකු තෝරා ගැනීමට අවශ්‍යයි',
        t285: 'සෑම සිසුවෙක්ම වාඩිලාගෙන සිටී',

        t286: 'දත්ත බාගන්න',
        t287: 'ශිෂ්‍ය අහඹුකරණය',
        t288: 'පරිවර්තක ගෙවීම් විස්තර',
        t289: 'ගුරු සම්බන්ධතා ලැයිස්තුව',
        t290: 'ලිපි හුවමාරු දත්ත',
        t291: 'ආකෘතිය: ',
        t292: 'ආකෘතිය තෝරන්න',

        t293: 'සහභාගිවන්නෙකු තෝරන්න',

        t294: 'සිසුන් සම්බන්ධ කිරීම. සංහිඳියාව ගොඩනැගීම.',
        t295: 'ඩිජිටල් පෑනේ මිතුරු අඩවියක්',
        t296:'සමගිය සහ අවබෝධය වර්ධනය කිරීම.',
        t297: 'සංහිඳියාවට අත්වැලක් යනු කුමක් ද?',
        t298: "සංහිඳියාවට අත්වැලක් යනු, ශ්‍රී ලංකාවේ සිසුන් අතර සමගිය ප්‍රවර්ධනය කරමින් සබඳතාවය ඇති කර ගැනීමට නිර්මාණය කළ ඩිජිටල් පෑනේ මිතුරු අඩවියකි. ගුරු මඟපෙන්වීමක් යටතේ සිසුන්ට පෑනේ මිතුරන් සොයා ගැනීමට, අදහස් හුවමාරු කර ගැනීමට සහ මිත්‍රත්වය පෝෂණය කිරීමට හැකියාව ඇත. මෙම අඩවියේ පරිවර්තකයන්ද සිටින අතර, ඔවුන් එකමුතු බව සහ අවබෝධය ප්‍රවර්ධනය කරන අර්ථවත් සංවාද ඇතුලත් බව සහතික කරමින්, සිසුන්ට සිංහල හා දෙමළ භාෂාවලින් බාධාවකින් තොරව සන්නිවේදනය කිරීමට සහාය ලබා දෙයි..",
        t299: 'දැනටමත් සහභාගී වන්නෙකු ද ?',
        t300: 'උපකරණ පුවරුවේ කැපී පෙනෙන දෑ',
        t301: 'පාසල් හවුල්කරුවන්',
        t302: 'සහභාගිවන මුළු පාසල් ගණන:',
        t303: 'මුළු සිසුන්:',
        t304: 'මුළු ගුරුවරුන්:',
        t305: 'ව්‍යාපෘතිය පිටුපස සිටින විශේෂඥයින් හමුවන්න',
        t306: 'අපේ සහායකයන් සහ සහයෝගීකරුවන්',
        t307: 'ගමන් මඟ බලන්න',
        t308: 'සහභාගී වන පාසල්',
        t309: 'බස්නාහිර පළාත:',
        t310: 'නැගෙනහිර පළාත:',
        t311: 'උතුරු පළාත:',
        t312: 'දකුණු පළාත:',
        t313: 'මධ්‍යම පළාත:',
        t314: 'උතුරු මැද පළාත:',
        t315: 'වයඹ පළාත:',
        t316: 'ඌව පළාත:',
        t317: 'සබරගමුව පළාත:',
        t318: 'සිසුන්',
        t319: 'ලිපි හුවමාරු කළා',
        t320: 'මෙම සතියේ යවා ඇති මුළු ලිපි ගණන:',
        t321: 'ලිපියක සාමාන්‍ය වචන ගණන:',
        t322: 'පරිවර්තනය කළ මුළු වචන ගණන:',
        t323: 'වචන',
        t324: 'සංවේදී ලකුණු',
        t325: 'ධනාත්මක',
        t326: 'ඍණාත්මක',
        t327: 'මධ්‍යස්ත',
        t328: 'අප අමතන්න',
        t329: 'පෞද්ගලිකත්ව ප්‍රතිපත්තිය',
        t330: 'සේවා කොන්දේසි',
        t331: 'සිසුන් සම්බන්ධ කිරීම,',
        t332: 'එක් අවස්ථාවක එක් ලියුමක්',
        t333: 'මිතුරන් වර්ධනය කිරීම සඳහා ඩිජිටල් පෑනේ මිතුරු අඩවියකි,',
        t334: 'ශ්‍රී ලංකාවේ සිසුන් අතර අවබෝධය සහ සංහිඳියාව වර්ධනය කිරීම.',
        t335: 'සංහිඳියාවට අත්වැලක් ගැන',
        t336: "සංහිඳියාවට අත්වැලක් හිදී, අර්ථාන්විත සම්බන්ධතාවලට ඇති බාධක බිඳ දමා වඩාත් එක්සත් අනාගතයක් ගොඩනගා ගත හැකි බව අපි විශ්වාස කරමු. අපගේ අඩවිය ශ්‍රී ලංකාව පුරා සිටින දෙමළ සහ සිංහල සිසුන් අතර මිත්‍රත්වය, අවබෝධය සහ සහයෝගීතාව වර්ධනය කිරීම සඳහා නිර්මාණය කර ඇති ඩිජිටල් පෑනේ මිතුරු වැඩසටහනකි. ලිපි හුවමාරු කිරීමේ බලය හරහා, අපි සිසුන්ට ඔවුන්ගේ සිතුවිලි, අත්දැකීම් සහ සංස්කෘතීන් ආරක්ෂිත සහ ව්‍යුහගත පරිසරයක් තුළ බෙදා ගැනීමට දිරිමත් කරමු. විවෘත සංවාදවල යෙදීමෙන්, සිසුන්ගේ සංවේදනය වර්ධනය කරයි, අගතීන් අඩු කරයි, සහ භූගෝලීය සහ වාර්ගික වෙනස්කම් ඉක්මවා යන කල්පවත්නා බැඳීම් ගොඩනඟා ගනී.",
        t337: "අපගේ අඩවිය භාෂා පරිවර්තනය, භාව විශ්ලේෂණය, සහ පර්යේෂකයන්ගේ තීක්ෂ්ණ බුද්ධිය ඒකාබද්ධ කරමින් සන්සුන් සංවාදයන් දියුණු කිරීමට සහ ධනාත්මක සමාජමය බලපෑම මැන ගැනීමට උපකාරී වේ. ගුරු, පර්යේෂක සහ සහයෝගී ආයතනවල සහය ඇතිව, අපි එකමුතුකම සහ අන්‍යෝන්‍ය ගෞරවය අගය කරන පරම්පරාවක් නිර්මාණය කිරීමට උත්සාහ කරමු.",
        t338: "වරකට එක අකුරක් බැඟින්, වඩාත් සුසංයෝගී සහ සම්බන්ධිත ශ්‍රී ලංකාවක් හැඩගැස්වීමට අප හා එක්වන්න,.",
        t339: "සහාය",
        t340: "අපගේ පුවත් ලිපිය සඳහා සබඳවන්න",
        t341: "අපගේ නිෂ්පාදනය ගැන නවතම ප්‍රවෘත්ති සහ යාවත්කාලීන",
        t342: "ලබා ගැනීමට කැමතිද? සබඳවන්න.",
        t343: "ඔබගේ විද්‍යුත් තැපෑල් ලිපිනය ඇතුළත් කරන්න",
        t344: "අපගේ පුවත් ලිපිය සඳහා සබඳවීමෙන්, ඔබ",
        t345: "'පෞද්ගලිකත්ව ප්‍රතිපත්තියට එකඟ වන අතර වෙළඳ දැන්වීම් ලැබේ.",
        t346: "'සංහිඳියාවට අත්වැලක්'.",
        t347: "ගිණුම තහවුරු කර නොමැත. කරුණාකර ඔබගේ ඊ-තැපැලට එවූ සබැඳිය ක්ලික් කිරීමෙන් මුලින්ම එය තහවුරු කරන්න.",
        t348: "මෙම පන්තියේ ගුරුවරයෙකු දැනටමත් හඳුනාගෙන ඇත. ලියාපදිංචිය අසාර්ථක විය.",
        t349: "පරිශීලකයා තවමත් ලියාපදිංචි වී නොමැත.",
        t350: "ප්රතික්ෂේප කරනවා",
        t351: "ඉදිරියට",
        t352: "නොගැළපෙන ශිෂ්‍යයන්ගේ විස්තර",
        t353: "ගුරුවරයෙකු ලෙස ලොගින් වන්න",
        t354: "ශිෂ්‍යයෙකු ලෙස ලොගින් වන්න",
        t355: "පර්යේෂකයෙකු ලෙස ලොගින් වන්න",
        t356: "පරිවර්තකයෙකු ලෙස ලොගින් වන්න",
        t357: "ගුරුවරයෙකු ලෙස ලියාපදිංචි වන්න",
        t358: "ශිෂ්‍යයෙකු ලෙස ලියාපදිංචි වන්න",
        t359: "පර්යේෂකයෙකු ලෙස ලියාපදිංචි වන්න",
        t360: "පරිවර්තකයෙකු ලෙස ලියාපදිංචි වන්න",
        t361: "වාර්ගිකත්වය",
        t362: "ජනවර්ගයක් තෝරන්න",

        t363: "ඔබගේ පෞද්ගලිකත්වය, අපගේ ප්‍රමුඛත්වයයි.",
        t364: "සංහිඳියාවට අත්වැලක් හිදී, අපි ඔබගේ පෞද්ගලිකත්වයට මුල් තැන ලබා දෙන අතර ඔබේ පුද්ගලික තොරතුරු ආරක්ෂා කිරීමට කැපවී සිටිමු. මෙම ප්‍රතිපත්තිය මඟින් අපි ඔබේ දත්ත රැස් කරන, භාවිතා කරන සහ ආරක්ෂා කරන ආකාරය පැහැදිලි කර සිටිමු.",
        t365: "අප එකතු කරගන්නා තොරතුරු",
        t366: "ආරක්ෂිත සහ ඵලදායී අත්දැකීමක් ලබා දීම සඳහා, අපි රැස් කරන්නේ:",
        t367: "ඔබගේ නම, වයස හා පාසල් විස්තර (සත්‍යතාව තහවුරු කිරීමට).",
        t368: "ඔබට උචිත භාෂාව (පෑනේ මිතුරන් ගැලපීම සඳහා).",
        t369: "අඩවිය හරහා හුවමාරු වූ විද්‍යුත් තැපැල් (ආරක්ෂාව සඳහා පවරා ඇති ගුරුවරුන් සහ පරිවර්තකයින් විසින් නිරීක්ෂණය කරනු ලැබේ).",
        t370: "අප ඔබගේ තොරතුරු භාවිතා කරන ආකාරය",
        t371: "අර්ථවත් සංවාද සඳහා සුදුසු පෑනේ මිතුරෙකු සමඟ ඔබව ගලපන්න.",
        t372: "භාෂාවන්ගේ වෙනස්කම් නොතකා සන්නිවේදනය කිරීමට හැකි වන පරිදි පරිවර්තන පණිවුඩ පරිවර්තන කිරීමට.",
        t373: "ගුරුවරුන්ට සංවාද නිරීක්ෂණය කිරීමට සහ ආරක්ෂිත පරිසරයක් පවත්වා ගැනීමට ඉඩ සැකසීමට.",
        t374: "දත්ත ආරක්ෂණය",
        t375: "ඔබගේ පෞද්ගලික තොරතුරු තෙවන පාර්ශ්වයන්ට බෙදා නොදෙන බව තහවුරු කිරීම.",
        t376: "ඔබගේ පණිවිඩ ඔබගේ පෑනේ මිතුරාට, පවරා ඇති ගුරුවරුන්ට හා පරිවර්තකයින්ට පමණක් දැක ගත හැක.",
        t377: "සියලුම දත්ත ආරක්ෂිතව තැන්පත් කර ඇති අතර  අවසර ලත් පිරිස් වලට  පමණක් ප්‍රවේශය ලබා දී ඇත.",
        t378: "ඔබගේ අයිතිවාසිකම්",
        t379: "ඔබට ඕනෑම වෙලාවක ඔබගේ ගිණුම මකා දැමීමට ඉල්ලීම් කල හැක.",
        t380: "ඔබට පෞද්ගලිකත්වය පිළිබඳ පැවසිය යුතු දෙයක් ඇත්නම්, bddivides@gmail.com හරහා අප හා සම්බන්ධ විය හැක.",

        t381: "ඔබට උදව් අවශ්‍යද? උදව් කිරීමට අපි සූදානම්!",
        t382: "සංහිඳියාවට අත්වැලක් අඩවිය තුළදී, ඔබගේ අත්දැකීම සුමටව, ආරක්ෂිතව සහ විනෝදජනක අන්දමින් පවත්වාගෙන යාම සඳහා අපි කැපවී සිටිමු. ඔබට උදව් අවශ්‍ය නම්, අප හා සම්බන්ධ වීමට පසුබට නොවන්න.",
        t383: "උදව් ලබා ගැනීමට ඔබ කළ යුතු දෑ",
        t384: "විද්‍යුත් තැපැල් සහය:",
        t385: "bddivides@gmail.com – ගැටලු, ප්‍රශ්න හෝ අදහස් සඳහා අප හා සම්බන්ධ වෙන්න.",
        t386: "දුරකතන සහය:",
        t387: "0771482755 – හදිසි කරුණු සඳහා අමතන්න.",
        t388: "අපට උදව් කළ හැකි පොදුවේ ඇති විය හැකි ගැටලු",
        t389: "ගිණුම් ලියාපදිංචි කිරීම සහ පරිශීලක පිවිසුම් ගැටලු.",
        t390: "පෑනේ මිතුරෙකු සොයා ගැනීම හෝ ගුරුවරයෙකු හා සම්බන්ධ වීම.",
        t391: "නුසුදුසු හැසිරීම් හෝ තාක්ෂණික ගැටලු වාර්තා කිරීම.",
        t392: "පරිවර්තන සිදු කෙරෙන ආකාරය තේරුම් ගැනීම.",
        t393: "සියලුම සහභාගිවන්නන් සඳහා හැකි ඉක්මණින් සහාය ලබා දීමට සහ ධනාත්මක ඉගෙනුම් පරිසරයක් පෝෂණය කිරීමට අපි කැපවී සිටිමු.",

        t394: "සංහිඳියාවට අත්වැලක් හි ලියාපදිංචි වීමේ දී, ඔබ පහත කොන්දේසි. පිළිගැනීමට එකඟ වේ.",
        t395: "1. සුදුසුකම්",
        t396: "මෙම වැඩසටහනට සහභාගී විය හැක්කේ, ලියාපදිංචි වුවන්ට පමණක් වේ. මෙම අඩවිය තුළට අනවසරින් ප්‍රවේශ විය නොහැක. පරිශීලකයින් ලියාපදිංචි වීමේදී නිවැරදි තොරතුරු සැපයිය යුතු අතර එමඟින්, ආරක්ෂිත සහ ව්‍යුහගත අත්දැකීමක් සහතික කෙරේ.",
        t397: "2. භාවිතා කරන්නන්ගේ වගකීම්",
        t398: "ඔබ ඔබේ පෑනේ මිතුරන් සමඟ ගෞරවාන්විතව සන්නිවේදනය කිරීමට සහ මාර්ගගත ආචාර ධර්ම හා බැඳුණු හැසිරීම් අනුගමනය කිරීමට මඟ බලා ගත යුතු වේ. ඔබ විසින් යවන පණිවිඩ, සුදුසු විය යුතු අතර එකමුතුකම සහ මිත්‍රත්වය වර්ධනය කිරීමේ ඉලක්කයට අනුකූල විය යුතුය. ආරක්ෂක හේතූන් මත පරිශීලකයින් අඩවියෙන් පිටත පුද්ගලික සම්බන්ධතා පිළිබඳ තොරතුරු බෙදා නොගත යුතුය.",
        t399: "3. නිරීක්ෂණය සහ විගණනය",
        t400: "ඕනෑම නුසුදුසු, හෝ හානිකර සන්නිවේදනයක් ක්ෂණික සමාලෝචනයකට ලක්වන අතර ඔබ ව මෙම වැඩසටහනෙන් ඉවත් කිරීමට හේතු විය හැක.",
        t401: "4. පෞද්ගලිකත්වය සහ දත්ත ආරක්ෂණය",
        t402: "භාවිතාකරුවන්ගේ තොරතුරුවල ආරක්ෂිත භාවය තහවුරු කරන අතර තෙවන පාර්ශවයන්ට බෙදා නොදීම ට අපි වග බලා ගනිමු.",
        t403: "වැඩි විස්තර සඳහා, කරුණාකර අපගේ පෞද්ගලිකත්වය සුරැකීමේ ප්‍රතිපත්තිය සමාලෝචනය කරන්න. ලියාපදිංචිය ඉදිරියට ගෙන යාමෙන්, ඔබ මෙම නියමයන්ට අනුකූල වීමට එකඟ වන අතර අනුකූල වීමට අපොහොසත් වීමෙන් ගිණුම අත්හිටුවීමට හේතු විය හැකි බව තේරුම් ගනී.",

        t404: "ගැලපුණු ශිෂ්‍යයන්",
        t405: "ඔයාට තාම පෑනේ මිතුරෙක් නෑ.",
        t406: "විද්‍යුත් තැපෑල: ",
        t407: "දුරකතන: ",
        t408: "කටුපිටපත සාර්ථකව මකා දමන ලදී.",
        t409: "දැනට පරිවර්තකයෙකු මෙය විධානය කරමින් සිටියි.",
        t410: "උපකරණ පුවරුව",
        t411: "ඔබේ තැපෑල්",
        t412: "බලන්න ක්ලික් කරන්න",
        t413: "(ශ්‍රිෂ්‍යයාගේ විස්තර බලන්න ඔහු/ඇය මත ක්ලික් කරන්න)",
        t414: "එම විද්‍යුත් තැපෑල සමඟ දැනටමත් පරිශීලකයෙකු හමු වී ඇත.",
        t415: "ක්‍රියාකාරී සිසුන්",
        t416: 'අවශ්‍ය භාෂාව',
        t417: "කිසිවක් නැත",
        t418: "කණ්ඩායම",
        t419: "කණ්ඩායමක් තෝරන්න",
        t420: "පොරොත්තු තැපැල්",
        t421: "පරිවර්තක විස්තර",
        t422: "බැංකු විස්තර",
        t423: 'මෙම ක්‍රියාවලිය මෙම පරිවර්තක ගිණුම ස්ථිරව මකා දමයි. කරුණාකර තහවුරු කරන්න.',

        t424: 'පරිවර්තක/ ගවේෂක විස්තර',
        t425: 'ගවේෂක විස්තර',

        t426: "පිළිතුර ලියන්න ",
        t427: "පිළිතුර යවන්න",
        t428: "තැපැල් භාෂාව",
        t429: "ශිෂ්‍යයන් අනුමත කරන්න",
        t430: "පාසල් පැවරීම",
        t431: "පාසල් හමු නොවීය",
        t432: "ගවේශකයින් හමු නොවීය",
        t433: "අනෙක්",
        t434: "යවන්නා",
        t435: "ස්කෑන් කරන්න",
        t436: "ඡායාරූපයක් ගන්න",
        t437: "අල්ලා ගැනීම",
        t438: "ඔබ මෙම සතිය තුළ පෑනේ මිතුරෙට පණිවිඩ 3ක් දැනටමත් යවා ඇත. කරුණාකර තවත් පණිවිඩ යැවීම සඳහා ලබන සතියට කාළයෙන්න.",
        t439: "පරිවර්තනය කළ තැපෑල් බාගන්න",
        t440: "තවමත් කිසිඳු තැපෑලක් පරිවර්තනය කර නැහැ",
        t441: "විද්‍යුත් තැපෑල හෝ පරිශීලක නාමය",
        t442: "විද්‍යුත් තැපෑල හෝ පරිශීලක නාමය අවශ්‍ය වේ",
        t443: "වලංගු නොවන විද්‍යුත් තැපෑලක් හෝ පරිශීලක නාමයකි.",
        t444: "එය විද්‍යුත් තැපෑලක් නම්, ආකෘතිය test@example.com වැනි එකක් විය යුතුය.",
        t445: "පරිශීලක නාමය අක්ෂර සහ ඉලක්කම් පමණක් සහිත අකුණු 7 කට වඩා දිග විය යුතුය",
        t446: 'ආරම්භ කරන්න',
        t447: 'පෙන්වීම',
        t448: "Please select your preferred language to continue. You can always change it later using options in top right corner.",
        t449: "වීඩියෝව නරඹීමට කරුණාකර ඔබගේ කැමති භාෂාව තෝරන්න.",
        t450: "ඔබට පෙර සාදන ලද <bold>ගිණුමක් තිබේ නම්</bold> පහත <bold>ඔව්</bold> බොත්තම ඔබන්න.",
        t451: "තවමත් <bold>ගිණුමක් නොමැතිනම් නැහැ</bold> බොත්තම ඔබන්න",
        t452: "පුද්ගලික විස්තර",
        t453: "මුරපදයක් සකසන්න",
        t454: "වෙනත් විස්තර",
        t455: "ආපසු",
        t456: "ලිපි හමු නොවීය",
        t457: "නොකියවූ පණිවිඩ",
        t457_2: "යි",
        t458: "පියවර 1",
        t459: "පියවර 2",
        t460: "ශිෂ්‍යයන් උඩුගත කරන්න හෝ පහතින් තෝරන්න.",
        t461: "එකම භාෂාවකින් ඇති ශිෂ්‍යයන් සඳහා Treat තෝරන්න, නැතහොත් වෙනස් භාෂාවකින් ඇති ශිෂ්‍යයන් සඳහා Control තෝරන්න. පසුව ඔවුන් සම්බන්ධ කිරීමට Match ක්ලික් කරන්න.",
        t462: "Excel sheet එකේ ආකෘතිය",
        t463: "පළමු column එක ශිෂ්‍යයාගේ email/username විය යුතුය.",
        t464: "දෙවන column එක penpalගේ email/username විය යුතුය.",
        t465: "column වලට මාතෘකා නොලියන්න.",
        t466: "තුන්වැනි column එක group විය යුතුය (CONTROL හෝ TREATMENT ලෙස විය යුතුය).",
        t467: "කරුණාකර ඔබගේ විද්‍යුත් තැපෑල සහ මුරපදය ඇතුළත් කරන්න.",
        t468: "කරුණාකර ඔබගේ විද්‍යුත් තැපෑල හෝ පරිශීලක නාමය සහ මුරපදය ඇතුළත් කරන්න.",
        t469: "එක් විද්‍යුත් තැපෑලකට වචන සීමාව වචන 500ක් වේ.",
        t470: "පණිවිඩ යැවීම ආරම්භ කරන්න ✉️",
        t471: "ඔබගේ නව පණිවිඩය දකුණු පස ඇති කොටුවේ ටයිප් කරන්න. ",
        t472: "ඔබේ මිතුරා අමතන්න, ඔබේ කතාව බෙදාගන්න, නැතහොත් ප‍්‍රශ්නයක් අසන්න! ඔබේ පෑන් මිතුරා ඔබ පණිවිඩයක් එවන තුරු බලා සිටී!",
        t473: "පණිවිඩ",
        t474: "ඔබගේ ගිණුමට පිවිසීමට ඔබගේ භූමිකාව (ශිෂ්‍ය, ගුරු, පරිවර්තක හෝ පර්යේෂක) තෝරන්න.",
        t475: "ඔබගේ ගිණුමට පිවිසීමට ඔබගේ භූමිකාව (ශිෂ්‍ය, ගුරු, පරිවර්තක හෝ පර්යේෂක) තෝරන්න.",
        t476: "ඇමිණීම",
        t477: "OCR",
      },
    }
  },
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language if translation is missing
  interpolation: { escapeValue: false }, // React already escapes values
});

export default i18n;
